import { coerceNumberProperty } from '@angular/cdk/coercion';
import { INFERRED_TYPE } from '@angular/compiler/src/output/output_ast';
import { Component, OnInit } from '@angular/core';
import { FormBuilder,FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import moment from 'moment';
import { UnitTreeNode } from 'src/app/masterscreen/model/unit-tree.model';
import { MasterscreenService } from 'src/app/masterscreen/services/masterscreen.service';
import { SearchText } from 'src/app/observation/model/searchTexts.model';
import { FileAttachment } from 'src/app/shared/models/file-attachment.model';
import { BaseService } from 'src/app/shared/services/base.service';
import { CommonService } from 'src/app/shared/services/common.service';
import { ConstantsService } from 'src/app/shared/services/constants.service';
import { HseErrorHandlerService } from 'src/app/shared/services/hse-error-handler.service';
import { NotificationsService } from 'src/app/shared/services/notification.service';
import { FileUtility } from 'src/app/shared/utility/file.utility';
import { PDPermission } from '../../model/performance.model';
import { PerformanceConstantsService, StatisticStatus } from '../../services/performance-constants.service';
import { PerformanceService } from '../../services/performance.service';
import { User, UserLogInActivity, UserLogInActivityDetails, UserPermissionParameters } from "../../../shared/models/user.model";
import { ObservationConstantsService } from "../../../observation/services/observation-constants.service";
import { ObservationService } from "../../../observation/services/observation.service";
import { Login } from "../../../observation/model/login.model";

@Component({
  selector: 'ara-contractor-statistic',
  templateUrl: './contractor-statistic.component.html',
  styleUrls: ['./contractor-statistic.component.css']
})
export class ContractorStatisticComponent implements OnInit {
  routesFlag: { routeName: string; routeURL: string; isClickable: boolean; }[];
  reportRoutes: { routeName: string; routeURL: string; isClickable: boolean; }[];
  CSForm: FormGroup;
  searchTexts: SearchText;
  userResults: User[] = [];
  independentPermissions: any;
  loggedInUserJSON: any;
  contracts: { label: string; value: string }[] = [];
  unitList: any;
  unitTree: UnitTreeNode[];
  isUpdate: boolean = false;
  dialogType: string;
  alertType: string;
  successDetails: any;
  errorDetails: any;
  confirmMessage: string;
  selectedUnit: any;
  contractorUnitSelected: boolean = false;
  flattenUnitTree: any[] = [];
  isContractor: boolean = false;
  status: number = 3;
  permissions: PDPermission = new PDPermission();
  IsApproveDisable: boolean = true;
  IsRejectDisable: boolean = true;
  sub: any;
  unitId: number;
  statisticId: number;
  display: boolean = true;
  statRequest: any;
  statStatus: any;
  isUpdateDisable: boolean = false;
  isResetDisable: boolean = false;
  statusName: string;
  isContractHolder: boolean = false;
  createdBy: number;
  unitContractDetails: any[] = [];
  isHasContractDetails: boolean = true;
  approverName: string = '';
  isApprovedReject: boolean = false;
  ApproveRejectDate: string = '';
  approvedRejectedDate: Date;
  isApprovalSectionShow: boolean = false;
  ApprovedRejectedDate: string = '';
  statisticsIds: number[] = [];
  locations: {Name : string,Value:number} [] = [];
  locationDetails: any[];
  login: Login;
  oldUnitId:number;
  oldUnit: any;
  isFormValid: boolean = true;
  supportEvidence :{Id: number, description : string; files: FileAttachment[] }[] = [];
  ContractorStatLocationDetail :LocationQtyDetails[] = [];
  NaturalGasProduction :LocationQtyDetails[] = [];
  TableFuelGasGenerators :LocationQtyDetails[] = [];
  TableFuelGasTreater :LocationQtyDetails[] = [];
  TableAllGasFlared :LocationQtyDetails[] = [];
  TableTotalProducedWater :LocationQtyDetails[] = [];
  TablePWReInjected :LocationQtyDetails[] = [];
  TablePWEvaporated :LocationQtyDetails[] = [];
  TableWaterAbstracted :LocationQtyDetails[] = [];
  TableEPFDGS :LocationQtyDetails[] = [];
  TableCampDGS :LocationQtyDetails[] = [];
  TableContractorDGS :LocationQtyDetails[] = [];
  TableVehicle :LocationQtyDetails[] = [];
  TableStationarySource :LocationQtyDetails[] = [];
  TableGenerators :LocationQtyDetails[] = [];
  TableWellsDGS :LocationQtyDetails[] = [];
  TableOther :LocationQtyDetails[] = [];
  TableMainsElectricity :LocationQtyDetails[] = [];
  //TableMainsElectricityEPF :LocationQtyDetails[] = [];
  TableMainsElectricityCamp :LocationQtyDetails[] = [];
  TableMainsElectricityWells :LocationQtyDetails[] = [];
  ShowNaturalGasProduction : boolean = false;
  ShowTableFuelGasGenerators : boolean = false;
  ShowTableFuelGasTreater : boolean = false;
  ShowTableAllGasFlared : boolean = false;
  ShowTableTotalProducedWater : boolean = false;
  ShowTablePWReInjected : boolean = false;
  ShowTablePWEvaporated : boolean = false;
  ShowTableWaterAbstracted : boolean = false;
  ShowTableEPFDGS : boolean = false;
  ShowTableCampDGS : boolean = false;
  ShowTableContractorDGS : boolean = false;
  ShowTableVehicle : boolean = false;
  ShowTableStationarySource : boolean = false;
  ShowTableGenerators : boolean = false;
  ShowTableWellsDGS : boolean = false;
  ShowTableOther : boolean = false;
  ShowTableMainsElectricity : boolean = false;
  //ShowTableMainsElectricityEPF : boolean = false;
  ShowTableMainsElectricityCamp : boolean = false;
  ShowTableMainsElectricityWells : boolean = false;

  addRecord(){	
    this.supportEvidence.push({Id : 0, description:"",files:[]});	
  }	
  GetLocationQtyDetails(id,componentId,quantity,location,QtyError,LocError)
  {
     return {Id : id,ComponentId : componentId, Quantity:quantity,LocationId:location,ShowQuantityErrorMessage:QtyError,ShowLocationIdErrorMessage:LocError,locations:this.locations}
  }
  addLocationRecord(component,componentId)
  {
    if(this.oldUnitId == null || this.oldUnitId == 0)
    {
      this.notificationsService.toastNotify(
        "error",
        "Error Message",
        "Kindly Select Unit and Proceed!"
      );
    }
    else
    {
    component.push(this.GetLocationQtyDetails(0,componentId,0,0,false,false));	
    this.checkTableRows();
    }
  }

  onRowDeleteInit(index){	
    this.supportEvidence.splice(index, 1);	
  }	

  onRowDelete(index,component){	
    switch(component)
     {
       case 'NaturalGasProduction' : this.NaturalGasProduction.splice(index, 1);	
                                     this.CSForm.patchValue({ NaturalGasProd:this.NaturalGasProduction.reduce((sum, current) => sum + current.Quantity, 0) });
                                     break;
       case 'TableFuelGasGenerators' : this.TableFuelGasGenerators.splice(index, 1);	
                                     this.CSForm.patchValue({ FuelGasGenerators:this.TableFuelGasGenerators.reduce((sum, current) => sum + current.Quantity, 0) });
                                     break;
       case 'TableFuelGasTreater' : this.TableFuelGasTreater.splice(index, 1);	
                                     this.CSForm.patchValue({ FuelGasTreater:this.TableFuelGasTreater.reduce((sum, current) => sum + current.Quantity, 0) });
                                     break;
       case 'TableAllGasFlared' : this.TableAllGasFlared.splice(index, 1);	
                                     this.CSForm.patchValue({ AllGasFlared:this.TableAllGasFlared.reduce((sum, current) => sum + current.Quantity, 0) });
                                     break;  
       case 'TableTotalProducedWater' : this.TableTotalProducedWater.splice(index, 1);	
                                     this.CSForm.patchValue({ TotalProducedWater:this.TableTotalProducedWater.reduce((sum, current) => sum + current.Quantity, 0) });
                                     break;
       case 'TablePWReInjected' : this.TablePWReInjected.splice(index, 1);	
                                     this.CSForm.patchValue({ PWReInjected:this.TablePWReInjected.reduce((sum, current) => sum + current.Quantity, 0) });
                                     break;
       case 'TablePWEvaporated' : this.TablePWEvaporated.splice(index, 1);	
                                     this.CSForm.patchValue({ PWEvaporated:this.TablePWEvaporated.reduce((sum, current) => sum + current.Quantity, 0) });
                                     break;
       case 'TableWaterAbstracted' : this.TableWaterAbstracted.splice(index, 1);	
                                     this.CSForm.patchValue({ WaterAbstracted:this.TableWaterAbstracted.reduce((sum, current) => sum + current.Quantity, 0) });
                                     break;    
       case 'TableEPFDGS' : this.TableEPFDGS.splice(index, 1);	
                                     this.CSForm.patchValue({ EPFDGS:this.TableEPFDGS.reduce((sum, current) => sum + current.Quantity, 0) });
                                     break;
       case 'TableCampDGS' : this.TableCampDGS.splice(index, 1);	
                                     this.CSForm.patchValue({ CampDGS:this.TableCampDGS.reduce((sum, current) => sum + current.Quantity, 0) });
                                     break;
       case 'TableContractorDGS' : this.TableContractorDGS.splice(index, 1);	
                                     this.CSForm.patchValue({ ContractorDGS:this.TableContractorDGS.reduce((sum, current) => sum + current.Quantity, 0) });
                                     break;
       case 'TableVehicle' : this.TableVehicle.splice(index, 1);	
                                     this.CSForm.patchValue({ Vehicle:this.TableVehicle.reduce((sum, current) => sum + current.Quantity, 0) });
                                     break;  
       case 'TableStationarySource' : this.TableStationarySource.splice(index, 1);	
                                     this.CSForm.patchValue({ StationarySource:this.TableStationarySource.reduce((sum, current) => sum + current.Quantity, 0) });
                                     break;
       case 'TableGenerators' : this.TableGenerators.splice(index, 1);	
                                     this.CSForm.patchValue({ Generators:this.TableGenerators.reduce((sum, current) => sum + current.Quantity, 0) });
                                     break;
       case 'TableWellsDGS' : this.TableWellsDGS.splice(index, 1);	
                                     this.CSForm.patchValue({ WellsDGS:this.TableWellsDGS.reduce((sum, current) => sum + current.Quantity, 0) });
                                     break;
       case 'TableOther' : this.TableOther.splice(index, 1);	
                                     this.CSForm.patchValue({ Other:this.TableOther.reduce((sum, current) => sum + current.Quantity, 0) });
                                     break;  
       case 'TableMainsElectricity' : this.TableMainsElectricity.splice(index, 1);	
                                     this.CSForm.patchValue({ MainsElectricity:this.TableMainsElectricity.reduce((sum, current) => sum + current.Quantity, 0) });
                                     break;    
      //  case 'TableMainsElectricityEPF' : this.TableMainsElectricityEPF.splice(index, 1);	
      //                                this.CSForm.patchValue({ MainsElectricityEPF:this.TableMainsElectricityEPF.reduce((sum, current) => sum + current.Quantity, 0) });
      //                                break; 
       case 'TableMainsElectricityCamp' : this.TableMainsElectricityCamp.splice(index, 1);	
                                     this.CSForm.patchValue({ MainsElectricityCamp:this.TableMainsElectricityCamp.reduce((sum, current) => sum + current.Quantity, 0) });
                                     break; 
       case 'TableMainsElectricityWells' : this.TableMainsElectricityWells.splice(index, 1);	
                                     this.CSForm.patchValue({ MainsElectricityWells:this.TableMainsElectricityWells.reduce((sum, current) => sum + current.Quantity, 0) });
                                     break;                                                                                                                                                                           
       default : 
                 break;                              
     }
     this.checkTableRows();
  }	

  onRowChange(component){	
    switch(component)
     {
       case 'NaturalGasProduction' : this.CSForm.patchValue({ NaturalGasProd:this.NaturalGasProduction.reduce((sum, current) => sum + current.Quantity, 0) });
                                     break;
       case 'TableFuelGasGenerators' : this.CSForm.patchValue({ FuelGasGenerators:this.TableFuelGasGenerators.reduce((sum, current) => sum + current.Quantity, 0) });
                                     break; 
       case 'TableFuelGasTreater' : this.CSForm.patchValue({ FuelGasTreater:this.TableFuelGasTreater.reduce((sum, current) => sum + current.Quantity, 0) });
                                     break;
       case 'TableAllGasFlared' : this.CSForm.patchValue({ AllGasFlared:this.TableAllGasFlared.reduce((sum, current) => sum + current.Quantity, 0) });
                                     break;  
       case 'TableTotalProducedWater' : this.CSForm.patchValue({ TotalProducedWater:this.TableTotalProducedWater.reduce((sum, current) => sum + current.Quantity, 0) });
                                     break;
       case 'TablePWReInjected' : this.CSForm.patchValue({ PWReInjected:this.TablePWReInjected.reduce((sum, current) => sum + current.Quantity, 0) });
                                     break; 
       case 'TablePWEvaporated' : this.CSForm.patchValue({ PWEvaporated:this.TablePWEvaporated.reduce((sum, current) => sum + current.Quantity, 0) });
                                     break;
       case 'TableWaterAbstracted' : this.CSForm.patchValue({ WaterAbstracted:this.TableWaterAbstracted.reduce((sum, current) => sum + current.Quantity, 0) });
                                     break; 
       case 'TableEPFDGS' : this.CSForm.patchValue({ EPFDGS:this.TableEPFDGS.reduce((sum, current) => sum + current.Quantity, 0) });
                                     break;
       case 'TableCampDGS' : this.CSForm.patchValue({ CampDGS:this.TableCampDGS.reduce((sum, current) => sum + current.Quantity, 0) });
                                     break; 
       case 'TableContractorDGS' : this.CSForm.patchValue({ ContractorDGS:this.TableContractorDGS.reduce((sum, current) => sum + current.Quantity, 0) });
                                     break;
       case 'TableVehicle' : this.CSForm.patchValue({ Vehicle:this.TableVehicle.reduce((sum, current) => sum + current.Quantity, 0) });
                                     break;  
       case 'TableStationarySource' : this.CSForm.patchValue({ StationarySource:this.TableStationarySource.reduce((sum, current) => sum + current.Quantity, 0) });
                                     break;
       case 'TableGenerators' : this.CSForm.patchValue({ Generators:this.TableGenerators.reduce((sum, current) => sum + current.Quantity, 0) });
                                     break; 
       case 'TableWellsDGS' : this.CSForm.patchValue({ WellsDGS:this.TableWellsDGS.reduce((sum, current) => sum + current.Quantity, 0) });
                                     break;
       case 'TableOther' : this.CSForm.patchValue({ Other:this.TableOther.reduce((sum, current) => sum + current.Quantity, 0) });
                                     break;  
       case 'TableMainsElectricity' : this.CSForm.patchValue({ MainsElectricity:this.TableMainsElectricity.reduce((sum, current) => sum + current.Quantity, 0) });
                                     break;    
      //  case 'TableMainsElectricityEPF' : this.CSForm.patchValue({ MainsElectricityEPF:this.TableMainsElectricityEPF.reduce((sum, current) => sum + current.Quantity, 0) });
      //                                break;  
       case 'TableMainsElectricityCamp' : this.CSForm.patchValue({ MainsElectricityCamp:this.TableMainsElectricityCamp.reduce((sum, current) => sum + current.Quantity, 0) });
                                     break;  
       case 'TableMainsElectricityWells' : this.CSForm.patchValue({ MainsElectricityWells:this.TableMainsElectricityWells.reduce((sum, current) => sum + current.Quantity, 0) });
                                     break;                                                                                                                                                   
       default : 
                 break;                              
     }
  }	

  onLocationChange(index,component,componentId,quantity){	
    let increment = 0;
    let exists = 0;
   
    if(component[index].LocationId !== 0 && component[index].LocationId.toString() !== "0")
    {
      component.forEach(record => {
      if(increment !== index &&  (record.LocationId === component[index].LocationId || (record.LocationId.toString() == component[index].LocationId.toString())))
      {
        if(exists !== 1)
        {
          this.notificationsService.toastNotify(
                                           "error",
                                           "Error Message",
                                           "Location Entry Already Exists....Kindly select other Location !"
                                             );
         component[index] = this.GetLocationQtyDetails(0,componentId,quantity,0,false,false);
         exists = 1;
        }
                                      
      }
      increment ++;
       });  
     }

  }	

  onInputFilesUpdated(files,index) {	
        this.supportEvidence[index].files = files;	
  }

  //BOC Pritesh
  dialogHeight: string;
  dialogWidth: string;
  ReportUserId : number;
  ReportModule : string;
  ReportRecordId : number;
  ReportProcessId : number = 0;
  ReportclosePopup: boolean = false;
  //EOC Pritesh
  


  updateActionTrack: any[];
  userActivityList: UserLogInActivity[] = [];
  updateSourceActionData: any;
  isNew: boolean = false;
  retVal: boolean;
  unitData : any;

  isNext: boolean = true;
  isPrevious: boolean = true;
  statisticIndex: number = -1;
  disableStatistic: boolean = false;
  statisticIds: any[];

  constructor(private formBuilder: FormBuilder, private commonService: CommonService,
    private hseErrorHandler: HseErrorHandlerService, private baseService: BaseService,private observationService: ObservationService,
    private masterscreenService: MasterscreenService, private PDService: PerformanceService,
    private notificationsService: NotificationsService, private route: ActivatedRoute, private router: Router,) {
    this.routesFlag = PerformanceConstantsService.PDNavigation.InnerRoutes;
    this.reportRoutes = PerformanceConstantsService.PDNavigation.ReportRoutes;
    this.login = new Login();
  }
  ngOnInit(): void {
    
    this.CSForm = this.formBuilder.group({
      ContraStatId: new FormControl(0, Validators.required),
      contractorName: new FormControl({ value: '', disabled: true }, Validators.required),
      // ContractNumber: new FormControl({ value: '', disabled: true }),
      BaseUnit: new FormControl('', Validators.required),
      Contract: new FormControl('', Validators.required),
      StatDate: new FormControl('', Validators.required),
      SafetyObsNotReported: new FormControl(''),
      HazardsTourConducetd: new FormControl(''),
      TrainingCompliance: new FormControl('', [Validators.required,Validators.min(0)]),
      FitnessToWork: new FormControl('', [Validators.required,Validators.min(0)]),
      EmergencyDrills: new FormControl(''),
      InspectionsAudits: new FormControl(''),
      VisitsByContractor: new FormControl(''),
      Manhours: new FormControl('', [Validators.required,Validators.min(0)]),
      PeopleOnBoardContractor: new FormControl('', [Validators.required,Validators.min(0)]),
      PeopleOnBoardSubContractor: new FormControl('', [Validators.required,,Validators.min(0)]),
      LightVehicles: new FormControl('', [Validators.required,Validators.min(0)]),
      KMLightVehicles: new FormControl('', [Validators.required,Validators.min(0)]),
      HeavyVehicles: new FormControl('', [Validators.required,Validators.min(0)]),
      KMHeavyVehicles: new FormControl('', [Validators.required,Validators.min(0)]),
      LightBusses: new FormControl('', [Validators.required,Validators.min(0)]),
      KMLightBusses: new FormControl('', [Validators.required,Validators.min(0)]),
      HeavyBusses: new FormControl('', [Validators.required,Validators.min(0)]),
      KMHeavyBusses: new FormControl('', [Validators.required,Validators.min(0)]),
      NaturalGasProd: new FormControl('', [Validators.min(0)]),
      FuelGasGen: new FormControl('', [Validators.min(0)]),
      FuelGasGenerators: new FormControl('', [Validators.min(0)]),
      FuelGasTreater: new FormControl('', [Validators.min(0)]),
      AllGasFlared: new FormControl('', [Validators.min(0)]),
      TotalProducedWater: new FormControl('', [Validators.min(0)]),
      PWReInjected: new FormControl('', [Validators.min(0)]),
      PWEvaporated: new FormControl('', [Validators.min(0)]),
      WaterAbstracted: new FormControl('', [Validators.min(0)]),
      EPFDGS: new FormControl('', [Validators.min(0)]),
      CampDGS: new FormControl('', [Validators.min(0)]),
      ContractorDGS: new FormControl('', [Validators.min(0)]),
      Vehicle: new FormControl('', [Validators.min(0)]),
      StationarySource: new FormControl('', [Validators.min(0)]),
      Generators: new FormControl('', [Validators.min(0)]),
      MainsElectricity: new FormControl('', [Validators.min(0)]),
      //MainsElectricityEPF: new FormControl(''),
      MainsElectricityCamp: new FormControl('', [Validators.min(0)]),
      MainsElectricityWells: new FormControl('', [Validators.min(0)]),
      WellsDGS: new FormControl(''),
      Other: new FormControl(''),
      WaterConsumption: new FormControl('', [Validators.min(0)]),
      HazardousWasteOily: new FormControl('', [Validators.min(0)]),
      HazardousWasteChemical: new FormControl('', [Validators.min(0)]),
      HazardousWasteDrilling: new FormControl('', [Validators.min(0)]),
      HazardousWasteOther: new FormControl('', [Validators.min(0)]),
      NonHazardScrap: new FormControl('', [Validators.min(0)]),
      NonHazardWood: new FormControl('', [Validators.min(0)]),
      NonHazardPlastic: new FormControl('', [Validators.min(0)]),
      NonHazardDomestic: new FormControl('', [Validators.min(0)]),
      NonHazardKitchen: new FormControl('', [Validators.min(0)]),
      SewageWater: new FormControl('', [Validators.min(0)]),
      OBMDisp: new FormControl('', [Validators.min(0)]),
      NumOfConsignmentNote: new FormControl('', [Validators.min(0)]),
      RejectRemark: new FormControl(''),	
      FileDescription: new FormControl('')
    });
    const loggedInUser = this.baseService.getItemFromSession("loggedInUser");
    this.independentPermissions = JSON.parse(
      this.baseService.getItemFromSession("UserIndependentPermissions")
    );
    this.loggedInUserJSON = JSON.parse(loggedInUser);

    this.sub = this.route.params.subscribe((params) => {
      this.statisticId = coerceNumberProperty(params["statisticId"])
      this.unitId = coerceNumberProperty(params["unitId"]);
    });
    this.getUnits();
    if(this.statisticId == null || this.statisticId == undefined || this.statisticId == 0)
    {
    this.oldUnitId = 0; 
    this.oldUnit = this.selectedUnit; 
    this.getLocations();
    }
    if (this.statisticId !== 0 && this.statisticId) {
      this.display = false;
    }
    else {
      this.CSForm.patchValue({ contractorName: this.loggedInUserJSON.FullName });
      this.createdBy = this.loggedInUserJSON.UserId;
      // this.CSForm.patchValue({ ContractNumber: this.loggedInUserJSON.ContractNumber });
    }
    this.checkTableRows();
  }

  serviceError() {
    this.hseErrorHandler.handleError(
      "Service (WebAPI) is not available or not in running mode"
    );
  }

  getUsersOnSearch(event) {
    this.searchTexts.UserTypeId = 0;
    this.searchTexts.FilterTexts = event.query;
    this.searchTexts.CompanyId = 0;
    this.searchTexts.UnitId = -1;
    const apiRequest = {
      Model: this.searchTexts
    };
    this.commonService.getSearchResultsForUsers(apiRequest, this.callbackMethodForGetSearchResultsForUsersData.bind(this));

  }

  callbackMethodForGetSearchResultsForUsersData(response) {
    if (response === undefined) {
      this.serviceError();
    }

    if (response.Success) {
      const filtered: any[] = [];
      response.Result = response.Result.filter(u => u.UserTypeId == 2);
      for (let i = 0; i < response.Result.length; i++) {
        const user = response.Result[i];
        if (
          user.FullName.toLowerCase().indexOf(
            this.searchTexts.FilterTexts.toLowerCase()
          ) !== -1
        ) {
          filtered.push(user);
        }
      }
      this.userResults = filtered;
    }

    if (response.Errors !== null) {
      this.hseErrorHandler.handleError(response.Errors);
    }
  }

  getUnits() {
    const apiRequestUnit = {
      Model: {
        ModuleId: ConstantsService.PermissionMatrixModules.PD,
        UserId: this.loggedInUserJSON.UserId,
        IsActive : 0
      },
    };
    this.masterscreenService.getUnits(
      apiRequestUnit,
      this.callbackMethodForUnitDetails.bind(this)
    );
  }
  callbackMethodForUnitDetails(response) {
    if (response.Success) {
      const unitDetails = response.Result;
      this.unitList = [];
      this.unitData= response.Result;
      unitDetails.forEach((unit) => {
        this.unitList.push({
          label: unit.UnitName,
          value: unit.UnitId,
          checked: true
        });
      });
    }
    this.getUnitTree();
  }

  getContractDetails(unitId: number): void {
    const apiRequestUnit = {
      Model: {
        "UnitId": unitId
      },
    };
    this.PDService.getContractDetailsData(
      apiRequestUnit,
      this.callbackMethodForContractDetails.bind(this)
    );
  }

  callbackMethodForContractDetails(response) {
    
    this.contracts = [];
    this.unitContractDetails = response;
    let contractHolderId;
    response.forEach(contract => {
      this.contracts.push({ label: contract.ContractNumber, value: contract.UnitContractDetailsId });
    });
    if (this.statisticId !== 0 && this.statisticId && this.contracts.some(c => c.value == this.statRequest.Contract)) {
      let currentContract = this.contracts.find(c => c.value === this.statRequest.Contract);
      this.CSForm.patchValue({ Contract: currentContract.value });
      this.checkHolder(currentContract);
      contractHolderId = response.find(h => h.UnitContractDetailsId === this.statRequest.Contract).ContractHolderId
      

      this.isContractHolder = contractHolderId === this.loggedInUserJSON.UserId ? true : false;

      
    }
  }

  CheckIsUpdateProcess() {
    if (this.statisticId !== 0 && this.statisticId) {
      this.baseService.showRootLoader = true;
      const apiRequest = {
        Model: {
          "ContraStatId": this.statisticId,
        }
      };
      this.PDService.getStatisticRequestByStatisticId(apiRequest, this.callbackMethodForGetRequestByStatisticId.bind(this))
    }
  }
  callbackMethodForGetRequestByStatisticId(response) { 
    this.baseService.showRootLoader = false;
    if (response.Success) {
    
      this.statRequest = response.Result;
      this.supportEvidence = response.Result.SupportEvidenceDocs;
      this.statisticId = this.statRequest.ContraStatId;
      this.isContractor = this.statRequest.contractorName === this.loggedInUserJSON.FullName ? true : false;
      this.isUpdate = true;
      this.selectedUnit = this.statRequest.BaseUnit;
      this.oldUnitId = this.selectedUnit;  
      //this.oldUnit = this.selectedUnit;
      //this.NaturalGasProduction = response.Result.ContractorStatLocationDetail.filter(u => u.ComponentId == 1);
      this.CSForm.patchValue({ BaseUnit: this.statRequest.BaseUnit });
      this.getContractDetails(this.statRequest.BaseUnit);
      this.unitTree.forEach(node => {
        this.compareTreeNode(node, this.statRequest.BaseUnit);
      });
      this.oldUnit = this.selectedUnit;
      this.status = this.statRequest.Status;
      this.statusName = this.statRequest.StatusName;
      this.CSForm.patchValue({ contractorName: this.statRequest.contractorName });
      // this.CSForm.patchValue({ ContractNumber: this.loggedInUserJSON.ContractNumber });
      this.createdBy = this.statRequest.CreatedBy;
      if (this.isUpdate) {
        if (this.status == StatisticStatus.Approved) {
          this.CSForm.disable();
          this.IsApproveDisable = true;
          this.IsRejectDisable = true;
        } else {
          this.CSForm.enable();
          this.CSForm.get("contractorName").disable();
         
        }
      }
      // this.CSForm.get("ContractNumber").disable();
      this.getPermissions(this.statRequest.BaseUnit);
      this.CSForm.patchValue({ ContraStatId: this.statRequest.ContraStatId, StatDate: moment(moment.utc(this.statRequest.StatDate).local()).toDate(), SafetyObsNotReported: this.statRequest.SafetyObsNotReported, HazardsTourConducetd: this.statRequest.HazardsTourConducetd, TrainingCompliance: this.statRequest.TrainingCompliance, FitnessToWork: this.statRequest.FitnessToWork, EmergencyDrills: this.statRequest.EmergencyDrills, InspectionsAudits: this.statRequest.InspectionsAudits, VisitsByContractor: this.statRequest.VisitsByContractor, Manhours: this.statRequest.Manhours, PeopleOnBoardContractor: this.statRequest.PeopleOnBoardContractor, PeopleOnBoardSubContractor: this.statRequest.PeopleOnBoardSubContractor, LightVehicles: this.statRequest.LightVehicles, KMLightVehicles: this.statRequest.KMLightVehicles, HeavyVehicles: this.statRequest.HeavyVehicles, KMHeavyVehicles: this.statRequest.KMHeavyVehicles, LightBusses: this.statRequest.LightBusses, KMLightBusses: this.statRequest.KMLightBusses, HeavyBusses: this.statRequest.HeavyBusses, KMHeavyBusses: this.statRequest.KMHeavyBusses, NaturalGasProd: this.statRequest.NaturalGasProd, FuelGasGen: this.statRequest.FuelGasGen, FuelGasTreater: this.statRequest.FuelGasTreater, AllGasFlared: this.statRequest.AllGasFlared, TotalProducedWater: this.statRequest.TotalProducedWater, PWReInjected: this.statRequest.PWReInjected, PWEvaporated: this.statRequest.PWEvaporated, WaterAbstracted: this.statRequest.WaterAbstracted, EPFDGS: this.statRequest.EPFDGS, CampDGS: this.statRequest.CampDGS, ContractorDGS: this.statRequest.ContractorDGS, Vehicle: this.statRequest.Vehicle, MainsElectricity: this.statRequest.MainsElectricity,MainsElectricityCamp: this.statRequest.MainsElectricityCamp,MainsElectricityWells: this.statRequest.MainsElectricityWells, WellsDGS: this.statRequest.WellsDGS, Other: this.statRequest.Other, WaterConsumption: this.statRequest.WaterConsumption, HazardousWasteOily: this.statRequest.HazardousWasteOily, HazardousWasteChemical: this.statRequest.HazardousWasteChemical, HazardousWasteDrilling: this.statRequest.HazardousWasteDrilling, HazardousWasteOther: this.statRequest.HazardousWasteOther, NonHazardScrap: this.statRequest.NonHazardScrap, NonHazardWood: this.statRequest.NonHazardWood, NonHazardPlastic: this.statRequest.NonHazardPlastic, NonHazardDomestic: this.statRequest.NonHazardDomestic, NonHazardKitchen: this.statRequest.NonHazardKitchen, SewageWater: this.statRequest.SewageWater, OBMDisp: this.statRequest.OBMDisp, NumOfConsignmentNote: this.statRequest.NumOfConsignmentNote, RejectRemark: this.statRequest.RejectRemark,FuelGasGenerators:this.statRequest.FuelGasGenerators,StationarySource:this.statRequest.StationarySource,Generators:this.statRequest.Generators });
      this.getLocations();
      this.baseService.showRootLoader = false;
      this.approvalDetails();
      this.NaturalGasProduction = response.Result.ContractorStatLocationDetail.filter(u => u.ComponentId == 1);
      this.TableFuelGasGenerators = response.Result.ContractorStatLocationDetail.filter(u => u.ComponentId == 2);
      this.TableFuelGasTreater = response.Result.ContractorStatLocationDetail.filter(u => u.ComponentId == 3);
      this.TableAllGasFlared = response.Result.ContractorStatLocationDetail.filter(u => u.ComponentId == 4);
      this.TableTotalProducedWater = response.Result.ContractorStatLocationDetail.filter(u => u.ComponentId == 5);
      this.TablePWReInjected = response.Result.ContractorStatLocationDetail.filter(u => u.ComponentId == 6);
      this.TablePWEvaporated = response.Result.ContractorStatLocationDetail.filter(u => u.ComponentId == 7);
      this.TableWaterAbstracted = response.Result.ContractorStatLocationDetail.filter(u => u.ComponentId == 8);
      this.TableEPFDGS = response.Result.ContractorStatLocationDetail.filter(u => u.ComponentId == 9);
      this.TableCampDGS = response.Result.ContractorStatLocationDetail.filter(u => u.ComponentId == 10);
      this.TableContractorDGS = response.Result.ContractorStatLocationDetail.filter(u => u.ComponentId == 11);
      this.TableVehicle = response.Result.ContractorStatLocationDetail.filter(u => u.ComponentId == 12);
      this.TableStationarySource = response.Result.ContractorStatLocationDetail.filter(u => u.ComponentId == 13);
      this.TableGenerators = response.Result.ContractorStatLocationDetail.filter(u => u.ComponentId == 14);
      this.TableWellsDGS = response.Result.ContractorStatLocationDetail.filter(u => u.ComponentId == 15);
      this.TableOther = response.Result.ContractorStatLocationDetail.filter(u => u.ComponentId == 16);
      this.TableMainsElectricity = response.Result.ContractorStatLocationDetail.filter(u => u.ComponentId == 17);
      //this.TableMainsElectricityEPF = response.Result.ContractorStatLocationDetail.filter(u => u.ComponentId == 18);
      this.TableMainsElectricityCamp = response.Result.ContractorStatLocationDetail.filter(u => u.ComponentId == 19);
      this.TableMainsElectricityWells = response.Result.ContractorStatLocationDetail.filter(u => u.ComponentId == 20);
      this.checkTableRows();
      this.PDService.setSourceActionData(
        JSON.stringify(this.statRequest)
      );
    }

    this.statisticIds = this.PDService.getAllCheckedStatisticRequestIds();
    if(this.statisticIds == null){
      this.isNext = false;
      this.isPrevious = false;
    }
    let currentIndex: number = 0;
    if (this.statisticIds) {
      this.statisticIds.forEach((element, index) => {
        if (element.statisticId === this.statisticId) {
          currentIndex = index;
          return;
        }
      });
      if (currentIndex === 0) {
        this.isPrevious = false;
      }
      if (currentIndex === this.statisticIds.length - 1) {
        this.isNext = false;
      }
    }
  }
  submitUpdateStatistics(SaveorUpdate: string) {
    this.baseService.showRootLoader = true;

    if (this.CSForm.valid && this.isHasContractDetails && this.checkValidation()) {
      this.GetContractorStatLocationDetail();
      const apiRequestUnit = {
        Model: {
          "SaveorUpdate": SaveorUpdate,
          "ContraStatId": this.CSForm.get('ContraStatId').value,
          "CreatedBy": this.createdBy,
          "ModifiedBy": this.loggedInUserJSON.UserId,
          "contractorName": this.CSForm.get('contractorName').value,
          "BaseUnit": this.CSForm.get('BaseUnit').value,
          "StatDate": moment(this.CSForm.get('StatDate').value).add(1, 'd'),
          "Status": this.status,
          "RejectRemark": this.CSForm.get('RejectRemark').value,

          "Contract": this.CSForm.get('Contract').value ? this.CSForm.get('Contract').value : 0,
          
          "SafetyObsNotReported": this.CSForm.value.SafetyObsNotReported ? this.CSForm.value.SafetyObsNotReported : 0,
          "HazardsTourConducetd": this.CSForm.value.HazardsTourConducetd ? this.CSForm.value.HazardsTourConducetd : 0,

          "TrainingCompliance": this.CSForm.value.TrainingCompliance ? this.CSForm.value.TrainingCompliance : 0,
          "FitnessToWork": this.CSForm.value.FitnessToWork ? this.CSForm.value.FitnessToWork : 0,

          "EmergencyDrills": this.CSForm.value.EmergencyDrills ? this.CSForm.value.EmergencyDrills : 0,
          "InspectionsAudits": this.CSForm.value.InspectionsAudits ? this.CSForm.value.InspectionsAudits : 0,
          "VisitsByContractor": this.CSForm.value.VisitsByContractor ? this.CSForm.value.VisitsByContractor : 0,

          "Manhours": this.CSForm.value.Manhours ? this.CSForm.value.Manhours : 0,
          "PeopleOnBoardContractor": this.CSForm.value.PeopleOnBoardContractor ? this.CSForm.value.PeopleOnBoardContractor : 0,
          "PeopleOnBoardSubContractor": this.CSForm.value.PeopleOnBoardSubContractor ? this.CSForm.value.PeopleOnBoardSubContractor : 0,
          "LightVehicles": this.CSForm.value.LightVehicles ? this.CSForm.value.LightVehicles : 0,
          "KMLightVehicles": this.CSForm.value.KMLightVehicles ? this.CSForm.value.KMLightVehicles : 0,
          "HeavyVehicles": this.CSForm.value.HeavyVehicles ? this.CSForm.value.HeavyVehicles : 0,
          "KMHeavyVehicles": this.CSForm.value.KMHeavyVehicles ? this.CSForm.value.KMHeavyVehicles : 0,
          "LightBusses": this.CSForm.value.LightBusses ? this.CSForm.value.LightBusses : 0,
          "KMLightBusses": this.CSForm.value.KMLightBusses ? this.CSForm.value.KMLightBusses : 0,
          "HeavyBusses": this.CSForm.value.HeavyBusses ? this.CSForm.value.HeavyBusses : 0,
          "KMHeavyBusses": this.CSForm.value.KMHeavyBusses ? this.CSForm.value.KMHeavyBusses : 0,

          "NaturalGasProd": this.CSForm.value.NaturalGasProd ? this.CSForm.value.NaturalGasProd : 0,
          "FuelGasGen": this.CSForm.value.FuelGasGen ? this.CSForm.value.FuelGasGen : 0,
          "FuelGasTreater": this.CSForm.value.FuelGasTreater ? this.CSForm.value.FuelGasTreater : 0,
          "AllGasFlared": this.CSForm.value.AllGasFlared ? this.CSForm.value.AllGasFlared : 0,
          "TotalProducedWater": this.CSForm.value.TotalProducedWater ? this.CSForm.value.TotalProducedWater : 0,
          "PWReInjected": this.CSForm.value.PWReInjected ? this.CSForm.value.PWReInjected : 0,
          "PWEvaporated": this.CSForm.value.PWEvaporated ? this.CSForm.value.PWEvaporated : 0,
          "WaterAbstracted": this.CSForm.value.WaterAbstracted ? this.CSForm.value.WaterAbstracted : 0,
          "EPFDGS": this.CSForm.value.EPFDGS ? this.CSForm.value.EPFDGS : 0,
          "CampDGS": this.CSForm.value.CampDGS ? this.CSForm.value.CampDGS : 0,
          "ContractorDGS": this.CSForm.value.ContractorDGS ? this.CSForm.value.ContractorDGS : 0,
          "Vehicle": this.CSForm.value.Vehicle ? this.CSForm.value.Vehicle : 0,
          "MainsElectricity": this.CSForm.value.MainsElectricity ? this.CSForm.value.MainsElectricity : 0,
          //"MainsElectricityEPF": this.CSForm.value.MainsElectricityEPF ? this.CSForm.value.MainsElectricityEPF : 0,
          "MainsElectricityCamp": this.CSForm.value.MainsElectricityCamp ? this.CSForm.value.MainsElectricityCamp : 0,
          "MainsElectricityWells": this.CSForm.value.MainsElectricityWells ? this.CSForm.value.MainsElectricityWells : 0,
          "WellsDGS": this.CSForm.value.WellsDGS ? this.CSForm.value.WellsDGS : 0,
          "Other": this.CSForm.value.Other ? this.CSForm.value.Other : 0,
          "WaterConsumption": this.CSForm.value.WaterConsumption ? this.CSForm.value.WaterConsumption : 0,
          "HazardousWasteOily": this.CSForm.value.HazardousWasteOily ? this.CSForm.value.HazardousWasteOily : 0,
          "HazardousWasteChemical": this.CSForm.value.HazardousWasteChemical ? this.CSForm.value.HazardousWasteChemical : 0,
          "HazardousWasteDrilling": this.CSForm.value.HazardousWasteDrilling ? this.CSForm.value.HazardousWasteDrilling : 0,
          "HazardousWasteOther": this.CSForm.value.HazardousWasteOther ? this.CSForm.value.HazardousWasteOther : 0,
          "NonHazardScrap": this.CSForm.value.NonHazardScrap ? this.CSForm.value.NonHazardScrap : 0,
          "NonHazardWood": this.CSForm.value.NonHazardWood ? this.CSForm.value.NonHazardWood : 0,
          "NonHazardPlastic": this.CSForm.value.NonHazardPlastic ? this.CSForm.value.NonHazardPlastic : 0,
          "NonHazardDomestic": this.CSForm.value.NonHazardDomestic ? this.CSForm.value.NonHazardDomestic : 0,
          "NonHazardKitchen": this.CSForm.value.NonHazardKitchen ? this.CSForm.value.NonHazardKitchen : 0,
          "SewageWater": this.CSForm.value.SewageWater ? this.CSForm.value.SewageWater : 0,
          "OBMDisp": this.CSForm.value.OBMDisp ? this.CSForm.value.OBMDisp : 0,
          "NumOfConsignmentNote": this.CSForm.value.NumOfConsignmentNote ? this.CSForm.value.NumOfConsignmentNote : 0,
          "IsDraft":false,
          "SupportEvidenceDocs" : this.supportEvidence,
          "ContractorStatLocationDetail" : this.ContractorStatLocationDetail,
          "FuelGasGenerators": this.CSForm.value.FuelGasGenerators ? this.CSForm.value.FuelGasGenerators : 0,
          "StationarySource": this.CSForm.value.StationarySource ? this.CSForm.value.StationarySource : 0,
          "Generators": this.CSForm.value.Generators ? this.CSForm.value.Generators : 0
        },
      };
      this.PDService.saveContractorStat(
        apiRequestUnit,
        this.callbackMethodForContractStat.bind(this)
      );
    }
    else {
      this.baseService.showRootLoader = false;
      this.notificationsService.toastNotify(
        "error",
        "Error Message",
        "Kindly Fill in all Mandatory Fields as well as Quantity/Location in added records!"
      );
    }
  }

  callbackMethodForContractStat(response) {
    this.baseService.showRootLoader = false;
    if (response && response.Success) {
      if (this.isUpdate) {
        this.notificationsService.toastNotify(
          'success',
          'Success Message',
          'Contractor Statistic Updated successfully'
        );
      } else {
        this.notificationsService.toastNotify(
          'success',
          'Success Message',
          'Contractor Statistic submitted successfully'
        );
      }
      this.router.navigate(["pd/overview"]);
      
    } else {
      this.notificationsService.toastNotify(
        'error',
        'Error Message',
        'something went wrong!'
      );
    }
    this.baseService.showRootLoader = false;
  this.trackDetails();
  
  
  }

   trackDetails() {
    const apiRequestUnit = {
      Model: {
       // "SaveorUpdate": SaveorUpdate,
        "ContraStatId": this.CSForm.get('ContraStatId').value,
        "CreatedBy": this.createdBy,
        "ModifiedBy": this.loggedInUserJSON.UserId,
        "contractorName": this.CSForm.get('contractorName').value,

       

        "BaseUnit": this.CSForm.get('BaseUnit').value,
        "StatDate": moment(this.CSForm.get('StatDate').value).add(1, 'd'),
        "Status": this.status,
        "RejectRemark": this.CSForm.get('RejectRemark').value,

        //"Contract": this.CSForm.get('Contract').value ? this.CSForm.get('Contract').value : 0,
       // "Contract": 0,
        "Contract": this.CSForm.get('Contract').value ? this.CSForm.get('Contract').value : 0,
        "SafetyObsNotReported": this.CSForm.value.SafetyObsNotReported ? this.CSForm.value.SafetyObsNotReported : 0,
        "HazardsTourConducetd": this.CSForm.value.HazardsTourConducetd ? this.CSForm.value.HazardsTourConducetd : 0,

        "TrainingCompliance": this.CSForm.value.TrainingCompliance ? this.CSForm.value.TrainingCompliance : 0,
        "FitnessToWork": this.CSForm.value.FitnessToWork ? this.CSForm.value.FitnessToWork : 0,

        "EmergencyDrills": this.CSForm.value.EmergencyDrills ? this.CSForm.value.EmergencyDrills : 0,
        "InspectionsAudits": this.CSForm.value.InspectionsAudits ? this.CSForm.value.InspectionsAudits : 0,
        "VisitsByContractor": this.CSForm.value.VisitsByContractor ? this.CSForm.value.VisitsByContractor : 0,

        "Manhours": this.CSForm.value.Manhours ? this.CSForm.value.Manhours : 0,
        "PeopleOnBoardContractor": this.CSForm.value.PeopleOnBoardContractor ? this.CSForm.value.PeopleOnBoardContractor : 0,
        "PeopleOnBoardSubContractor": this.CSForm.value.PeopleOnBoardSubContractor ? this.CSForm.value.PeopleOnBoardSubContractor : 0,
        "LightVehicles": this.CSForm.value.LightVehicles ? this.CSForm.value.LightVehicles : 0,
        "KMLightVehicles": this.CSForm.value.KMLightVehicles ? this.CSForm.value.KMLightVehicles : 0,
        "HeavyVehicles": this.CSForm.value.HeavyVehicles ? this.CSForm.value.HeavyVehicles : 0,
        "KMHeavyVehicles": this.CSForm.value.KMHeavyVehicles ? this.CSForm.value.KMHeavyVehicles : 0,
        "LightBusses": this.CSForm.value.LightBusses ? this.CSForm.value.LightBusses : 0,
        "KMLightBusses": this.CSForm.value.KMLightBusses ? this.CSForm.value.KMLightBusses : 0,
        "HeavyBusses": this.CSForm.value.HeavyBusses ? this.CSForm.value.HeavyBusses : 0,
        "KMHeavyBusses": this.CSForm.value.KMHeavyBusses ? this.CSForm.value.KMHeavyBusses : 0,

        "NaturalGasProd": this.CSForm.value.NaturalGasProd ? this.CSForm.value.NaturalGasProd : 0,
        "FuelGasGen": this.CSForm.value.FuelGasGen ? this.CSForm.value.FuelGasGen : 0,
        "FuelGasTreater": this.CSForm.value.FuelGasTreater ? this.CSForm.value.FuelGasTreater : 0,
        "AllGasFlared": this.CSForm.value.AllGasFlared ? this.CSForm.value.AllGasFlared : 0,
        "TotalProducedWater": this.CSForm.value.TotalProducedWater ? this.CSForm.value.TotalProducedWater : 0,
        "PWReInjected": this.CSForm.value.PWReInjected ? this.CSForm.value.PWReInjected : 0,
        "PWEvaporated": this.CSForm.value.PWEvaporated ? this.CSForm.value.PWEvaporated : 0,
        "WaterAbstracted": this.CSForm.value.WaterAbstracted ? this.CSForm.value.WaterAbstracted : 0,
        "EPFDGS": this.CSForm.value.EPFDGS ? this.CSForm.value.EPFDGS : 0,
        "CampDGS": this.CSForm.value.CampDGS ? this.CSForm.value.CampDGS : 0,
        "ContractorDGS": this.CSForm.value.ContractorDGS ? this.CSForm.value.ContractorDGS : 0,
        "Vehicle": this.CSForm.value.Vehicle ? this.CSForm.value.Vehicle : 0,
        "MainsElectricity": this.CSForm.value.MainsElectricity ? this.CSForm.value.MainsElectricity : 0,
        //"MainsElectricityEPF": this.CSForm.value.MainsElectricityEPF ? this.CSForm.value.MainsElectricityEPF : 0,
        "MainsElectricityCamp": this.CSForm.value.MainsElectricityCamp ? this.CSForm.value.MainsElectricityCamp : 0,
        "MainsElectricityWells": this.CSForm.value.MainsElectricityWells ? this.CSForm.value.MainsElectricityWells : 0,
        "WellsDGS": this.CSForm.value.WellsDGS ? this.CSForm.value.WellsDGS : 0,
        "Other": this.CSForm.value.Other ? this.CSForm.value.Other : 0,
        "WaterConsumption": this.CSForm.value.WaterConsumption ? this.CSForm.value.WaterConsumption : 0,
        "HazardousWasteOily": this.CSForm.value.HazardousWasteOily ? this.CSForm.value.HazardousWasteOily : 0,
        "HazardousWasteChemical": this.CSForm.value.HazardousWasteChemical ? this.CSForm.value.HazardousWasteChemical : 0,
        "HazardousWasteDrilling": this.CSForm.value.HazardousWasteDrilling ? this.CSForm.value.HazardousWasteDrilling : 0,
        "HazardousWasteOther": this.CSForm.value.HazardousWasteOther ? this.CSForm.value.HazardousWasteOther : 0,
        "NonHazardScrap": this.CSForm.value.NonHazardScrap ? this.CSForm.value.NonHazardScrap : 0,
        "NonHazardWood": this.CSForm.value.NonHazardWood ? this.CSForm.value.NonHazardWood : 0,
        "NonHazardPlastic": this.CSForm.value.NonHazardPlastic ? this.CSForm.value.NonHazardPlastic : 0,
        "NonHazardDomestic": this.CSForm.value.NonHazardDomestic ? this.CSForm.value.NonHazardDomestic : 0,
        "NonHazardKitchen": this.CSForm.value.NonHazardKitchen ? this.CSForm.value.NonHazardKitchen : 0,
        "SewageWater": this.CSForm.value.SewageWater ? this.CSForm.value.SewageWater : 0,
        "OBMDisp": this.CSForm.value.OBMDisp ? this.CSForm.value.OBMDisp : 0,
        "NumOfConsignmentNote": this.CSForm.value.NumOfConsignmentNote ? this.CSForm.value.NumOfConsignmentNote : 0,
       // "IsDraft":false
      "SupportEvidenceDocs" : this.supportEvidence ,
       "UnitName":this.unitData.find(x=>x.UnitId === this.CSForm.get('BaseUnit').value).UnitName,
       "ContractorStatLocationDetail" : this.ContractorStatLocationDetail,
       "FuelGasGenerators": this.CSForm.value.FuelGasGenerators ? this.CSForm.value.FuelGasGenerators : 0,
       "StationarySource": this.CSForm.value.StationarySource ? this.CSForm.value.StationarySource : 0,
       "Generators": this.CSForm.value.Generators ? this.CSForm.value.Generators : 0

      },
    };
    if (!this.statisticId) {
      this.isNew = true;
      this.updateSourceActionData = null;
    } 
    else {
      this.updateSourceActionData = JSON.parse(
        this.PDService.getSourceActionData()
      );
    }
    const columnNames = Object.getOwnPropertyNames(
      this.statRequest
    );
    columnNames.forEach(element => {
      if (this.updateSourceActionData === null) 
      {
        this.retVal = false;
      } else 
      {
        this.retVal = this.commonService.isDataEqual(
          this.updateSourceActionData[element],
          apiRequestUnit.Model[element]
        );
      }
      if (this.retVal === false) 
      {
        const userLoginActivity = new UserLogInActivity();
        userLoginActivity.FieldName = element;
       if (element === "contraStatId") {
        
        userLoginActivity.OldValue = this.isNew
          ? null
          : this.updateSourceActionData[element];
        
        userLoginActivity.NewValue = apiRequestUnit.Model[element];
        this.userActivityList.push(userLoginActivity);
      }
    //  else if (element === "UserId") {
          
    //   userLoginActivity.OldValue = this.isNew
    //   ? null
    //   : this.updateSourceActionData[element];
    
    // userLoginActivity.NewValue = apiRequestUnit.Model[element];
    // this.userActivityList.push(userLoginActivity);
        
    //     }
        
        else if (element === "ContractorName") {
         
          userLoginActivity.OldValue = this.isNew
          ? null
          : this.updateSourceActionData[element];
        
        userLoginActivity.NewValue = apiRequestUnit.Model[element];
        this.userActivityList.push(userLoginActivity);
            
        }
      else if (element === "ApprovrdRejectedBy") {
        userLoginActivity.OldValue = this.isNew
      ? null
      : this.updateSourceActionData[element];
    
    userLoginActivity.NewValue = apiRequestUnit.Model[element];
    this.userActivityList.push(userLoginActivity);
        
      }
      else if (element === " BaseUnit") {
        userLoginActivity.OldValue = this.isNew
      ? null
      : this.updateSourceActionData[element];
    
    userLoginActivity.NewValue = apiRequestUnit.Model[element];
    this.userActivityList.push(userLoginActivity);
        
      }
      else if (element === "Contract") {
        userLoginActivity.FieldName = "Contract Number";
        userLoginActivity.OldValue = this.isNew
      ? null
      : this.updateSourceActionData[element];
    
    userLoginActivity.NewValue = apiRequestUnit.Model[element];
    this.userActivityList.push(userLoginActivity);
        
      }
  

 

       
    //   else if (element === "ContractNumber") {
    //     userLoginActivity.OldValue = this.isNew
    //   ? null
    //   : this.updateSourceActionData[element];
    
    // userLoginActivity.NewValue = apiRequestUnit.Model[element];
    // this.userActivityList.push(userLoginActivity);
        
    //   }
      else if (element === "ContractholderId") {
        userLoginActivity.OldValue = this.isNew
      ? null
      : this.updateSourceActionData[element];
    
    userLoginActivity.NewValue = apiRequestUnit.Model[element];
    this.userActivityList.push(userLoginActivity);
        
      }
    //   else if (element === "ApproverName") {
    //     userLoginActivity.OldValue = this.isNew
    //   ? null
    //   : this.updateSourceActionData[element];
    
    // userLoginActivity.NewValue = apiRequestUnit.Model[element];
    // this.userActivityList.push(userLoginActivity);
        
    //   }
      else if (element === "SafetyObsNotReported") {
        userLoginActivity.OldValue = this.isNew
      ? null
      : this.updateSourceActionData[element];
    
    userLoginActivity.NewValue = apiRequestUnit.Model[element];
    this.userActivityList.push(userLoginActivity);
        
      }
      else if (element === "HazardsTourConducetd") {
        userLoginActivity.OldValue = this.isNew
      ? null
      : this.updateSourceActionData[element];
    
    userLoginActivity.NewValue = apiRequestUnit.Model[element];
    this.userActivityList.push(userLoginActivity);
        
      }
      else if (element === "TrainingCompliance") {
        userLoginActivity.OldValue = this.isNew
      ? null
      : this.updateSourceActionData[element];
    
    userLoginActivity.NewValue = apiRequestUnit.Model[element];
    this.userActivityList.push(userLoginActivity);
        
      }
      else if (element === "FitnessToWork") {
        userLoginActivity.OldValue = this.isNew
      ? null
      : this.updateSourceActionData[element];
    
    userLoginActivity.NewValue = apiRequestUnit.Model[element];
    this.userActivityList.push(userLoginActivity);
        
      }
      else if (element === "EmergencyDrills") {
        userLoginActivity.OldValue = this.isNew
      ? null
      : this.updateSourceActionData[element];
    
    userLoginActivity.NewValue = apiRequestUnit.Model[element];
    this.userActivityList.push(userLoginActivity);
        
      }
      else if (element === "InspectionsAudits") {
        userLoginActivity.OldValue = this.isNew
      ? null
      : this.updateSourceActionData[element];
    
    userLoginActivity.NewValue = apiRequestUnit.Model[element];
    this.userActivityList.push(userLoginActivity);
        
      }
      else if (element === "VisitsByContractor") {
        userLoginActivity.OldValue = this.isNew
      ? null
      : this.updateSourceActionData[element];
    
    userLoginActivity.NewValue = apiRequestUnit.Model[element];
    this.userActivityList.push(userLoginActivity);
        
      }
      else if (element === "Manhours") {
        userLoginActivity.OldValue = this.isNew
      ? null
      : this.updateSourceActionData[element];
    
    userLoginActivity.NewValue = apiRequestUnit.Model[element];
    this.userActivityList.push(userLoginActivity);
        
      }
      else if (element === "PeopleOnBoardContractor") {
        userLoginActivity.OldValue = this.isNew
      ? null
      : this.updateSourceActionData[element];
    
    userLoginActivity.NewValue = apiRequestUnit.Model[element];
    this.userActivityList.push(userLoginActivity);
        
      }
      else if (element === "PeopleOnBoardSubContractor") {
        userLoginActivity.OldValue = this.isNew
      ? null
      : this.updateSourceActionData[element];
    
    userLoginActivity.NewValue = apiRequestUnit.Model[element];
    this.userActivityList.push(userLoginActivity);
        
      }
      else if (element === "LightVehicles") {
        userLoginActivity.OldValue = this.isNew
      ? null
      : this.updateSourceActionData[element];
    
    userLoginActivity.NewValue = apiRequestUnit.Model[element];
    this.userActivityList.push(userLoginActivity);
        
      }
      else if (element === "KMLightVehicles") {
        userLoginActivity.OldValue = this.isNew
      ? null
      : this.updateSourceActionData[element];
    
    userLoginActivity.NewValue = apiRequestUnit.Model[element];
    this.userActivityList.push(userLoginActivity);
        
      }
      else if (element === "HeavyVehicles") {
        userLoginActivity.OldValue = this.isNew
      ? null
      : this.updateSourceActionData[element];
    
    userLoginActivity.NewValue = apiRequestUnit.Model[element];
    this.userActivityList.push(userLoginActivity);
        
      }
      else if (element === "KMHeavyVehicles") {
        userLoginActivity.OldValue = this.isNew
      ? null
      : this.updateSourceActionData[element];
    
    userLoginActivity.NewValue = apiRequestUnit.Model[element];
    this.userActivityList.push(userLoginActivity);
        
      }
      else if (element === "LightBusses") {
        userLoginActivity.OldValue = this.isNew
      ? null
      : this.updateSourceActionData[element];
    
    userLoginActivity.NewValue = apiRequestUnit.Model[element];
    this.userActivityList.push(userLoginActivity);
        
      }
      else if (element === "KMLightBusses") {
        userLoginActivity.OldValue = this.isNew
      ? null
      : this.updateSourceActionData[element];
    
    userLoginActivity.NewValue = apiRequestUnit.Model[element];
    this.userActivityList.push(userLoginActivity);
        
      }
      else if (element === "HeavyBusses") {
        userLoginActivity.OldValue = this.isNew
      ? null
      : this.updateSourceActionData[element];
    
    userLoginActivity.NewValue = apiRequestUnit.Model[element];
    this.userActivityList.push(userLoginActivity);
        
      }
      else if (element === "KMHeavyBusses") {
        userLoginActivity.OldValue = this.isNew
      ? null
      : this.updateSourceActionData[element];
    
    userLoginActivity.NewValue = apiRequestUnit.Model[element];
    this.userActivityList.push(userLoginActivity);
        
      }
      else if (element === "NaturalGasProd") {
        userLoginActivity.OldValue = this.isNew
      ? null
      : this.updateSourceActionData[element];
    
    userLoginActivity.NewValue = apiRequestUnit.Model[element];
    this.userActivityList.push(userLoginActivity);
        
      }
      else if (element === "FuelGasGenerators") {
        userLoginActivity.OldValue = this.isNew
      ? null
      : this.updateSourceActionData[element];
    
    userLoginActivity.NewValue = apiRequestUnit.Model[element];
    this.userActivityList.push(userLoginActivity);
        
      }
      else if (element === "FuelGasTreater") {
        userLoginActivity.OldValue = this.isNew
      ? null
      : this.updateSourceActionData[element];
    
    userLoginActivity.NewValue = apiRequestUnit.Model[element];
    this.userActivityList.push(userLoginActivity);
        
      }
      else if (element === "AllGasFlared") {
        userLoginActivity.OldValue = this.isNew
      ? null
      : this.updateSourceActionData[element];
    
    userLoginActivity.NewValue = apiRequestUnit.Model[element];
    this.userActivityList.push(userLoginActivity);
        
      }
      else if (element === "TotalProducedWater") {
        userLoginActivity.OldValue = this.isNew
      ? null
      : this.updateSourceActionData[element];
    
    userLoginActivity.NewValue = apiRequestUnit.Model[element];
    this.userActivityList.push(userLoginActivity);
        
      }
      else if (element === "PWReInjected") {
        userLoginActivity.OldValue = this.isNew
      ? null
      : this.updateSourceActionData[element];
    
    userLoginActivity.NewValue = apiRequestUnit.Model[element];
    this.userActivityList.push(userLoginActivity);
        
      }
      else if (element === "PWEvaporated") {
        userLoginActivity.OldValue = this.isNew
      ? null
      : this.updateSourceActionData[element];
    
    userLoginActivity.NewValue = apiRequestUnit.Model[element];
    this.userActivityList.push(userLoginActivity);
        
      }
      else if (element === "WaterAbstracted") {
        userLoginActivity.OldValue = this.isNew
      ? null
      : this.updateSourceActionData[element];
    
    userLoginActivity.NewValue = apiRequestUnit.Model[element];
    this.userActivityList.push(userLoginActivity);
        
      }
      else if (element === "EPFDGS") {
        userLoginActivity.OldValue = this.isNew
      ? null
      : this.updateSourceActionData[element];
    
    userLoginActivity.NewValue = apiRequestUnit.Model[element];
    this.userActivityList.push(userLoginActivity);
        
      }
      else if (element === "CampDGS") {
        userLoginActivity.OldValue = this.isNew
      ? null
      : this.updateSourceActionData[element];
    
    userLoginActivity.NewValue = apiRequestUnit.Model[element];
    this.userActivityList.push(userLoginActivity);
        
      }
      else if (element === "ContractorDGS") {
        userLoginActivity.OldValue = this.isNew
      ? null
      : this.updateSourceActionData[element];
    
    userLoginActivity.NewValue = apiRequestUnit.Model[element];
    this.userActivityList.push(userLoginActivity);
        
      }
      else if (element === "Vehicle") {
        userLoginActivity.OldValue = this.isNew
      ? null
      : this.updateSourceActionData[element];
    
    userLoginActivity.NewValue = apiRequestUnit.Model[element];
    this.userActivityList.push(userLoginActivity);
        
      }
      else if (element === "StationarySource") {
        userLoginActivity.OldValue = this.isNew
      ? null
      : this.updateSourceActionData[element];
    
    userLoginActivity.NewValue = apiRequestUnit.Model[element];
    this.userActivityList.push(userLoginActivity);
        
      }
      else if (element === "Generators") {
        userLoginActivity.OldValue = this.isNew
      ? null
      : this.updateSourceActionData[element];
    
    userLoginActivity.NewValue = apiRequestUnit.Model[element];
    this.userActivityList.push(userLoginActivity);
        
      }
      else if (element === "MainsElectricity") {
        userLoginActivity.FieldName = "Mains Electricity - EPF";
        userLoginActivity.OldValue = this.isNew
      ? null
      : this.updateSourceActionData[element];
    
    userLoginActivity.NewValue = apiRequestUnit.Model[element];
    this.userActivityList.push(userLoginActivity);
        
      }
  //   else if (element === "MainsElectricityEPF") {
  //     userLoginActivity.OldValue = this.isNew
  //   ? null
  //   : this.updateSourceActionData[element];
  
  // userLoginActivity.NewValue = apiRequestUnit.Model[element];
  // this.userActivityList.push(userLoginActivity);
      
  //   }
    else if (element === "MainsElectricityCamp") {
      userLoginActivity.OldValue = this.isNew
    ? null
    : this.updateSourceActionData[element];
  
  userLoginActivity.NewValue = apiRequestUnit.Model[element];
  this.userActivityList.push(userLoginActivity);
      
    }
    else if (element === "MainsElectricityWells") {
      userLoginActivity.OldValue = this.isNew
    ? null
    : this.updateSourceActionData[element];
  
  userLoginActivity.NewValue = apiRequestUnit.Model[element];
  this.userActivityList.push(userLoginActivity);
      
    }
      else if (element === "WellsDGS") {
        userLoginActivity.OldValue = this.isNew
      ? null
      : this.updateSourceActionData[element];
    
    userLoginActivity.NewValue = apiRequestUnit.Model[element];
    this.userActivityList.push(userLoginActivity);
        
      }
      else if (element === "Other") {
        userLoginActivity.OldValue = this.isNew
      ? null
      : this.updateSourceActionData[element];
    
    userLoginActivity.NewValue = apiRequestUnit.Model[element];
    this.userActivityList.push(userLoginActivity);
        
      }
      else if (element === "WaterConsumption") {
        userLoginActivity.OldValue = this.isNew
      ? null
      : this.updateSourceActionData[element];
    
    userLoginActivity.NewValue = apiRequestUnit.Model[element];
    this.userActivityList.push(userLoginActivity);
        
      }
      else if (element === "HazardousWasteOily") {
        userLoginActivity.OldValue = this.isNew
      ? null
      : this.updateSourceActionData[element];
    
    userLoginActivity.NewValue = apiRequestUnit.Model[element];
    this.userActivityList.push(userLoginActivity);
        
      }
      else if (element === "HazardousWasteChemical") {
        userLoginActivity.OldValue = this.isNew
      ? null
      : this.updateSourceActionData[element];
    
    userLoginActivity.NewValue = apiRequestUnit.Model[element];
    this.userActivityList.push(userLoginActivity);
        
      }
      else if (element === "HazardousWasteDrilling") {
        userLoginActivity.OldValue = this.isNew
      ? null
      : this.updateSourceActionData[element];
    
    userLoginActivity.NewValue = apiRequestUnit.Model[element];
    this.userActivityList.push(userLoginActivity);
        
      }
      else if (element === "HazardousWasteOther") {
        userLoginActivity.OldValue = this.isNew
      ? null
      : this.updateSourceActionData[element];
    
    userLoginActivity.NewValue = apiRequestUnit.Model[element];
    this.userActivityList.push(userLoginActivity);
        
      }
      else if (element === "NonHazardScrap") {
        userLoginActivity.OldValue = this.isNew
      ? null
      : this.updateSourceActionData[element];
    
    userLoginActivity.NewValue = apiRequestUnit.Model[element];
    this.userActivityList.push(userLoginActivity);
        
      }
      else if (element === "NonHazardWood") {
        userLoginActivity.OldValue = this.isNew
      ? null
      : this.updateSourceActionData[element];
    
    userLoginActivity.NewValue = apiRequestUnit.Model[element];
    this.userActivityList.push(userLoginActivity);
        
      }
      else if (element === "NonHazardPlastic") {
        userLoginActivity.OldValue = this.isNew
      ? null
      : this.updateSourceActionData[element];
    
    userLoginActivity.NewValue = apiRequestUnit.Model[element];
    this.userActivityList.push(userLoginActivity);
        
      }
      else if (element === "NonHazardDomestic") {
        userLoginActivity.OldValue = this.isNew
      ? null
      : this.updateSourceActionData[element];
    
    userLoginActivity.NewValue = apiRequestUnit.Model[element];
    this.userActivityList.push(userLoginActivity);
        
      }
      else if (element === "NonHazardKitchen") {
        userLoginActivity.OldValue = this.isNew
      ? null
      : this.updateSourceActionData[element];
    
    userLoginActivity.NewValue = apiRequestUnit.Model[element];
    this.userActivityList.push(userLoginActivity);
        
      }
      else if (element === "SewageWater") {
        userLoginActivity.OldValue = this.isNew
      ? null
      : this.updateSourceActionData[element];
    
    userLoginActivity.NewValue = apiRequestUnit.Model[element];
    this.userActivityList.push(userLoginActivity);
        
      }
      else if (element === "OBMDisp") {
        userLoginActivity.OldValue = this.isNew
      ? null
      : this.updateSourceActionData[element];
    
    userLoginActivity.NewValue = apiRequestUnit.Model[element];
    this.userActivityList.push(userLoginActivity);
        
      }
      else if (element === "NumOfConsignmentNote") {
        userLoginActivity.OldValue = this.isNew
      ? null
      : this.updateSourceActionData[element];
    
    userLoginActivity.NewValue = apiRequestUnit.Model[element];
    this.userActivityList.push(userLoginActivity);
        
      }
      else if (element === "CreatedBy") {
        userLoginActivity.OldValue = this.isNew
      ? null
      : this.updateSourceActionData[element];
    
    userLoginActivity.NewValue = apiRequestUnit.Model[element];
    this.userActivityList.push(userLoginActivity);
        
      }
      else if (element === "ModifiedBy") {
        userLoginActivity.OldValue = this.isNew
      ? null
      : this.updateSourceActionData[element];
    
    userLoginActivity.NewValue = apiRequestUnit.Model[element];
    this.userActivityList.push(userLoginActivity);
        
      }
      else if (element === "StatDate") {
        const userLoginActivity = new UserLogInActivity();
        userLoginActivity.FieldName = "ReportedMonth";
        userLoginActivity.OldValue = this.isNew
      ? null
      : this.updateSourceActionData[element];
    
    userLoginActivity.NewValue = apiRequestUnit.Model[element];
    this.userActivityList.push(userLoginActivity);
        
      }
    //   else if (element === "CreatedDate") {
    //     userLoginActivity.OldValue = this.isNew
    //   ? null
    //   : this.updateSourceActionData[element];
    
    // userLoginActivity.NewValue = apiRequestUnit.Model[element];
    // this.userActivityList.push(userLoginActivity);
        
    //   }
    //   else if (element === "ModifiedDate") {
    //     userLoginActivity.OldValue = this.isNew
    //   ? null
    //   : this.updateSourceActionData[element];
    
    // userLoginActivity.NewValue = apiRequestUnit.Model[element];
    // this.userActivityList.push(userLoginActivity);
        
    //   }
      else if (element === "Status") {
        userLoginActivity.OldValue = this.isNew
      ? null
      : this.updateSourceActionData[element];
    
    userLoginActivity.NewValue = apiRequestUnit.Model[element];
    this.userActivityList.push(userLoginActivity);
        
      }
      else if (element === "RejectRemark") {
        userLoginActivity.OldValue = this.isNew
      ? null
      : this.updateSourceActionData[element];
    
    userLoginActivity.NewValue = apiRequestUnit.Model[element];
    this.userActivityList.push(userLoginActivity);
        
      }
    //   else if (element === "StatusName") {
    //     userLoginActivity.OldValue = this.isNew
    //   ? null
    //   : this.updateSourceActionData[element];
    
    // userLoginActivity.NewValue = apiRequestUnit.Model[element];
    // this.userActivityList.push(userLoginActivity);
        
    //   }
      else if (element === "UnitName") {
        userLoginActivity.OldValue = this.isNew
      ? null
      : this.updateSourceActionData[element];
    
    userLoginActivity.NewValue = apiRequestUnit.Model[element];
    this.userActivityList.push(userLoginActivity);
        
      }
     
      else if (element === "ContractorStatLocationDetail") {
         this.ReportLogForLocationQuantityTables(this.updateSourceActionData[element],apiRequestUnit.Model[element],1,"NaturalGasProd");
         this.ReportLogForLocationQuantityTables(this.updateSourceActionData[element],apiRequestUnit.Model[element],2,"FuelGasGenerators");
         this.ReportLogForLocationQuantityTables(this.updateSourceActionData[element],apiRequestUnit.Model[element],3,"FuelGasHeaterTreater");
         this.ReportLogForLocationQuantityTables(this.updateSourceActionData[element],apiRequestUnit.Model[element],4,"AllGasFlared");
         this.ReportLogForLocationQuantityTables(this.updateSourceActionData[element],apiRequestUnit.Model[element],5,"TotalProducedWater");
         this.ReportLogForLocationQuantityTables(this.updateSourceActionData[element],apiRequestUnit.Model[element],6,"PWReInjected");
         this.ReportLogForLocationQuantityTables(this.updateSourceActionData[element],apiRequestUnit.Model[element],7,"PWEvaporated");
         this.ReportLogForLocationQuantityTables(this.updateSourceActionData[element],apiRequestUnit.Model[element],8,"WaterAbstracted");
         this.ReportLogForLocationQuantityTables(this.updateSourceActionData[element],apiRequestUnit.Model[element],9,"EPFDGS");
         this.ReportLogForLocationQuantityTables(this.updateSourceActionData[element],apiRequestUnit.Model[element],10,"CampDGS");
         this.ReportLogForLocationQuantityTables(this.updateSourceActionData[element],apiRequestUnit.Model[element],11,"ContractorDGS");
         this.ReportLogForLocationQuantityTables(this.updateSourceActionData[element],apiRequestUnit.Model[element],12,"Vehicle");
         this.ReportLogForLocationQuantityTables(this.updateSourceActionData[element],apiRequestUnit.Model[element],13,"StationarySources");
         this.ReportLogForLocationQuantityTables(this.updateSourceActionData[element],apiRequestUnit.Model[element],14,"Generators");
         this.ReportLogForLocationQuantityTables(this.updateSourceActionData[element],apiRequestUnit.Model[element],15,"WellsDGS");
         this.ReportLogForLocationQuantityTables(this.updateSourceActionData[element],apiRequestUnit.Model[element],16,"Other");
         this.ReportLogForLocationQuantityTables(this.updateSourceActionData[element],apiRequestUnit.Model[element],17,"MainsElectricity - EPF");
        // this.ReportLogForLocationQuantityTables(this.updateSourceActionData[element],apiRequestUnit.Model[element],18,"MainsElectricity - EPF");
         this.ReportLogForLocationQuantityTables(this.updateSourceActionData[element],apiRequestUnit.Model[element],19,"MainsElectricity - Camp");
         this.ReportLogForLocationQuantityTables(this.updateSourceActionData[element],apiRequestUnit.Model[element],20,"MainsElectricity - Wells");

        }   
      
        else if (element === "SupportEvidenceDocs")
        {
          let oldValueCount = this.updateSourceActionData[element] == null ? 0 : this.updateSourceActionData[element].length;
          let newValueCount = apiRequestUnit.Model[element] == null ? 0 : apiRequestUnit.Model[element].length;
          let length = oldValueCount > newValueCount ? oldValueCount : newValueCount;
          for(var i=0;i<length;i++)
          {
             //Document Name Comparison
             const userLoginActivity = new UserLogInActivity();
             userLoginActivity.FieldName = " Support Evidence Document Name " + " " + (i+1);
             userLoginActivity.OldValue = this.updateSourceActionData[element][i] != undefined ? this.updateSourceActionData[element][i].description : ""; 
             userLoginActivity.NewValue = apiRequestUnit.Model[element][i] != undefined ? apiRequestUnit.Model[element][i].description : "";
            if(userLoginActivity.OldValue != userLoginActivity.NewValue)
            {
              this.userActivityList.push(userLoginActivity);
            }
             
             //Documents Comparison
             const userLoginActivity6 = new UserLogInActivity();
          userLoginActivity6.FieldName = "Support Evidence Documents  " + " " + (i+1) ;
          if (this.updateSourceActionData[element][i] != undefined && this.updateSourceActionData[element][i].files.length > 0) {
            for (var j = 0; j < this.updateSourceActionData[element][i].files.length; j++) {
              const url = this.updateSourceActionData[element][i].files[j]
                .Name;
              userLoginActivity6.OldValue += url + ",";
            }
          } else {
            userLoginActivity6.OldValue = "";
          }
          if (apiRequestUnit.Model[element][i] != undefined && apiRequestUnit.Model[element][i].files.length > 0) {
            for (var j = 0; j < apiRequestUnit.Model[element][i].files.length; j++) {
              const url = apiRequestUnit.Model[element][i].files[j]
                .Name;
              userLoginActivity6.NewValue += url + ",";
            }
          } else {
            userLoginActivity6.NewValue = "";
          }
          if(userLoginActivity6.OldValue != userLoginActivity6.NewValue)
          {
            this.userActivityList.push(userLoginActivity6);
          }
          }     
        }
    }
    });
    if (this.userActivityList.length > 0) {
      this.commonService.saveUserActivityDetails(
        this.isNew
          ? this.statisticId
          : this.statRequest.ContraStatId,
        new Date(),
        "PD",
        this.loggedInUserJSON.UserId,
        this.userActivityList
      );
    }
  }

  ReportLogForLocationQuantityTables(oldValue,newValue,Id,componentName)
  {
    oldValue = oldValue.filter(u => u.ComponentId == Id);
    newValue = newValue.filter(u => u.ComponentId == Id);
    let oldValueCount = oldValue == null ? 0 : oldValue.length;
    let newValueCount = newValue == null ? 0 : newValue.length;
    let length = oldValueCount > newValueCount ? oldValueCount : newValueCount;
    for(var i=0;i<length;i++)
    {
 //Quantity Comparison
const userLoginActivity = new UserLogInActivity();
userLoginActivity.FieldName = componentName + " - Quantity "+ " " + (i+1);
userLoginActivity.OldValue = oldValue[i] != undefined ? oldValue[i].Quantity : 0; 
userLoginActivity.NewValue = newValue[i] != undefined ? newValue[i].Quantity : 0;
if(userLoginActivity.OldValue != userLoginActivity.NewValue)
{
 this.userActivityList.push(userLoginActivity);
}
       
//Location Comparison
const userLoginActivity1 = new UserLogInActivity();
userLoginActivity1.FieldName = componentName + " - Location "+ " " + (i+1);
userLoginActivity1.OldValue = oldValue[i] != undefined ? parseInt(oldValue[i].LocationId) : 0; 
userLoginActivity1.NewValue = newValue[i] != undefined ? parseInt(newValue[i].LocationId) : 0;
if(userLoginActivity1.OldValue != userLoginActivity.NewValue)
{
 this.userActivityList.push(userLoginActivity1);
}
}
  }

  ResetForm() {
    this.dialogType = "ConfirmReset";
    this.alertType = "Confirm";
    this.successDetails = null;
    this.errorDetails = null;
    this.confirmMessage = "You have clicked reset button. All information entered by you on this page will be lost. Do you want to reset the form?";
  }


  onOkClickedForConfirmation() {
    switch (this.dialogType) {
      case "CheckDuplicatePermit":
        window.location.reload();
        break;
    }
    this.dialogType = "";
    this.alertType = "";
  }
  onYesClickedForConfirmation() {
    switch (this.dialogType) {
      case "AdminUpdatePermit":
        this.submitUpdateStatistics('Update');
        break;
      case "ConfirmReset":
        window.location.reload();
        break;
      case "UnitChange":
          this.ResetAllLocationQuantityTables();
          this.oldUnitId = this.selectedUnit ? this.selectedUnit.UnitId : 0;
          this.oldUnit = this.selectedUnit;
          this.contractorUnitSelected = true;
          this.CSForm.patchValue({ BaseUnit: this.selectedUnit.UnitId });
          this.getContractDetails(this.selectedUnit.UnitId);
          this.getPermissions(this.selectedUnit.UnitId);
          this.getLocations();
          break;
    }
    this.dialogType = "";
    this.alertType = "";
  }
  onNoClickedForConfirmation() {
    switch (this.dialogType) {
      case "AdminUpdatePermit":
        break;
      case "ConfirmReset":
        break;
      case "UnitChange":
        this.selectedUnit = this.oldUnit;
        break;  
    }
    this.dialogType = "";
    this.alertType = "";
  }

  nodeSelected(event) {
    
    if(this.oldUnitId !== 0 && this.oldUnitId != event.node.UnitId)
    {
      this.dialogType = "UnitChange";
      this.alertType = "Confirm";
      this.successDetails = null;
      this.errorDetails = null;
      this.confirmMessage = "You are about to change the Unit.This will delete all Quantity and Location details. Do you want to proceed?";  
    }
    else
    {
    this.selectedUnit = event.node;
    this.oldUnit = this.selectedUnit;
    this.contractorUnitSelected = true;
    this.CSForm.patchValue({ BaseUnit: this.selectedUnit.UnitId });
    this.oldUnitId = this.selectedUnit.UnitId;
    this.getContractDetails(this.selectedUnit.UnitId);
    this.getPermissions(this.selectedUnit.UnitId);
    this.getLocations();
    }
  }

  getUnitTree() {
    const apiRequest = {
      Model: {
        GetActiveNodes: true,
        UserId: this.loggedInUserJSON.UserId
      }
    };
    this.masterscreenService.getTreeData(
      apiRequest,
      this.callbackMethodForGetTreeData.bind(this)
    );
  }

  callbackMethodForGetTreeData(response) {
    if (response.Result) {
      this.unitTree = response.Result;
      if (!this.statisticId) {
        this.unitTree.forEach(node => {
          this.compareTreeNode(node, 0);
        });
      }
    }
    this.CheckIsUpdateProcess();
  }
  compareTreeNode(node, selectedNode) {
    var isFound: boolean = false;
    this.unitList.forEach((element) => {
      if (element.value === node.UnitId) {
        isFound = true;
      }
    });
    if (!isFound || !node.IsActive || node.UnitTypeId != 2) {
      node.selectable = false;
      node.expanded = false;
    }
    if (node.ParentId !== 0) {
      node.expanded = false;
    }
    if (node.UnitId == selectedNode) {
      this.selectedUnit = node;
      this.CSForm.get("BaseUnit").setValue(node.UnitId);
      this.expandParents(this.selectedUnit);
    }
    if (node.children && node.children.length > 0) {
      node.selectable = false;
      node.children.forEach((element) => {
        var isFound: boolean = false;
        this.unitList.forEach((unit) => {
          if (unit.value == element.UnitId) {
            isFound = true;
          }
        });
        if (!isFound || !element.IsActive || element.UnitTypeId != 2) {
          element.selectable = false;
          element.expanded = false;
        }
        if (element.ParentId !== 0) {
          element.expanded = false;
        }
        if (element.UnitId == selectedNode) {
          this.selectedUnit = element;
          this.expandParents(this.selectedUnit);
        }
        if (element.children && element.children.length > 0) {
          this.compareTreeNode(element, selectedNode);
        }
      });
    }
  }

  expandParents(node) {
    if (node.parent) {
      node.parent.expanded = true;
      this.expandParents(node.parent);
    }
  }


  saveApproval(approvalType) {
    switch (approvalType) {
      case "Approve":
        this.status = StatisticStatus.Approved;
        this.CSForm.value.RejectRemark = "";
        this.saveContraStatApproval(this.status);
        break;
      case "Reject":
        if (this.CSForm.value.RejectRemark == "") {
          this.notificationsService.toastNotify(
            "error",
            "Error Message",
            "Please add Remark for Reject"
          );
          this.baseService.showRootLoader = false;
          this.hseErrorHandler.handleError("Please add Remark for Reject");
        }
        else {
          this.status = StatisticStatus.Rejected;
          this.saveContraStatApproval(this.status);
        }
        this.status = StatisticStatus.Rejected;
        break;
      default:
        this.status = StatisticStatus.PendingForApproval;
        break;
    }
  }

  getPermissions(unitId) {
    let userPermissionParams: UserPermissionParameters = new UserPermissionParameters();
    userPermissionParams.UserId = this.loggedInUserJSON.UserId;
    userPermissionParams.ModuleId =
      ConstantsService.PermissionMatrixModules.PD;
    userPermissionParams.UnitId = unitId;
    const apiRequest = {
      Model: userPermissionParams,
    };
    this.commonService.getPermissionDetailsForUser(
      apiRequest,
      this.callbackMethodForUserPermissions.bind(this)
    );
  }

  callbackMethodForUserPermissions(response) {
    if (response.Success) {
      this.permissions = new PDPermission();
      this.permissions = response.Result.PDPermission;

      if (
        !this.permissions.PD_ContractHolder_Approve &&
        !this.permissions.PD_Add &&
        !this.permissions.PD_Add_Unit &&
        !this.permissions.PD_Admin &&
        !this.permissions.PD_Admin_Unit && this.routesFlag.some(x => x.routeName == "Contractor Statistics")
      ) {
        this.routesFlag.find(s => s.routeName == "Contractor Statistics").isClickable = false;
      }

      if (this.isUpdate) {
        let contractHolderName: string;
        
        this.CSForm.disable();
        this.IsApproveDisable = true;
        this.IsRejectDisable = true;
        this.isUpdateDisable = true;
        this.isResetDisable = true;
        this.CSForm.get('RejectRemark').disable();

        if (this.isContractor && (this.status == StatisticStatus.PendingForApproval || this.status == StatisticStatus.Rejected || this.status == StatisticStatus.Draft)) {
          this.CSForm.enable();
          this.CSForm.get("contractorName").disable();
          this.isUpdateDisable = false;
          this.isResetDisable = false;
        }
        else if (this.isContractHolder) {
          debugger
          this.CSForm.disable();
        }
        if ((this.permissions.PD_Admin || this.permissions.PD_Admin_Unit || this.permissions.PD_ContractHolder_Approve)) {
          this.CSForm.enable();
          this.IsApproveDisable = this.status === StatisticStatus.Rejected ? false : true;
          this.IsRejectDisable = this.status === StatisticStatus.Approved ? false : true;
          this.isUpdateDisable = false;
          this.isResetDisable = false;
          this.CSForm.get('RejectRemark').enable();
        }

        if (this.isContractHolder || this.permissions.PD_Admin || this.permissions.PD_Admin_Unit || this.permissions.PD_ContractHolder_Approve) {
          if (this.status == StatisticStatus.Rejected) {
            this.IsApproveDisable = false;
            this.IsRejectDisable = true;
            this.CSForm.get('RejectRemark').disable();
          } else if (this.status == StatisticStatus.PendingForApproval) {
            this.IsApproveDisable = false;
            this.IsRejectDisable = false;
            this.CSForm.get('RejectRemark').enable();
          }
        }

        if (this.isUpdate) {
          if (this.status == StatisticStatus.Cancelled || this.status == StatisticStatus.Deleted) {
            this.isApprovalSectionShow = false;
          } else {
            this.isApprovalSectionShow = true;
          }
        }
       
      if (this.unitContractDetails.find(h => h.UnitContractDetailsId === this.statRequest.Contract)!=null)
        contractHolderName = this.unitContractDetails.find(h => h.UnitContractDetailsId === this.statRequest.Contract).ContractHolderName

        if (this.status != StatisticStatus.Approved && this.status != StatisticStatus.Rejected) {
          if (this.isContractHolder || this.permissions.PD_Admin || this.permissions.PD_Admin_Unit || this.permissions.PD_ContractHolder_Approve) {
            this.approverName = this.loggedInUserJSON.FullName;
          } else {
            this.approverName = contractHolderName;
          }
        } else {
          this.approverName = this.statRequest.ApproverName;
        }
      }
    }
  }

  saveContraStatApproval(status: number) {
    this.baseService.showRootLoader = true;
    const apiRequest = {
      Model: {
        "Status": status,
        "ContraStatId": this.CSForm.get('ContraStatId').value,
        "RejectRemark": this.CSForm.get('RejectRemark').value,
        "ApprovedRejectedBy": this.loggedInUserJSON.UserId
      }
    };
    this.PDService.saveContraStatApproval(apiRequest, this.callbackMethodForSaveContraStatApproval.bind(this));

  }

  callbackMethodForSaveContraStatApproval(response) {
    if (response.Success) {
      if (response.Result === true) {
        this.notificationsService.toastNotify(
          "success",
          "Success Message",
          "Approval status saved successfully."
        );
        this.router.navigate(["pd/overview"]);
      } else {
        this.notificationsService.toastNotify(
          "error",
          "Error Message",
          "Something went wrong."
        );
      }
      this.baseService.showRootLoader = false;
    }
  }

  // onPrevNextClick(value: string) {
  //  // this.PDService.getAllStatisticRequestIds().forEach(id => {
  //   this.PDService.getAllCheckedStatisticRequestIds().forEach(id => {
  //     this.statisticsIds.push(id.StatisticId);
  //   });
  //   switch (value) {
  //     case 'Previous':
  //       let currentIndex = this.statisticsIds.findIndex(id => id == this.statisticId)
  //       if (currentIndex > 0) {
  //         this.statisticId = this.statisticsIds[currentIndex - 1];
  //         this.router.navigate(["pd/statistic/" + this.statisticId]);
  //         this.ngOnInit();
  //       }
  //       break;
  //     case 'Next':
  //       if (this.statisticsIds.find(id => id > this.statisticId)) {
  //         this.statisticId = this.statisticsIds.find(id => id > this.statisticId);
  //         this.router.navigate(["pd/statistic/" + this.statisticId]);
  //         this.ngOnInit();
  //       }
  //       // window.location.reload();
  //       break;
  //   }
  // }
  onPreviousClick() {
    this.isNext = true;
    this.statisticIndex = -1;
    this.disableStatistic = false;
    this.statisticIds = this.PDService.getAllCheckedStatisticRequestIds();
    if(this.statisticIds !==null && this.statisticIds.length >=0){
    this.statisticIds.forEach((element, index) => {
      if (element.statisticId  == this.statisticId && index - 1 != null) {
        this.statisticIndex = index - 1;
        if (this.statisticIndex <= 0) {
          this.isPrevious = false;
        } else {
          this.isPrevious = true;
        }
        return;
      }
    });
  }
 
    this.statisticId = this.statisticIds[this.statisticIndex].statisticId;
    if (this.statisticIndex  > -1) {
      this.baseService.showRootLoader = true;
      const apiRequest = {
        Model: {
          "ContraStatId": this.statisticId,
        }
      };
      this.PDService.getStatisticRequestByStatisticId(apiRequest, this.callbackMethodForGetRequestByStatisticId.bind(this));
      this.router.navigate(["pd/statistic/" + this.statisticId]);
  
    }
  
}

  onNextClick() {
    this.isPrevious = true;
    this.statisticIndex = -1;
    this.disableStatistic = false;
    this.statisticIds = this.PDService.getAllCheckedStatisticRequestIds();
    
    if(this.statisticIds !=null && this.statisticIds.length >=0){
    this.statisticIds.forEach((element, index) => {
      if (element.statisticId == this.statisticId && index + 1 != null) {
        this.statisticIndex= index + 1;
        if (this.statisticIndex + 1 == this.statisticIds.length ) {
          this.isNext = false;
        } else {
          this.isNext = true;
        }
        return;
      }
      

    });
  }
 
  this.statisticId = this.statisticIds[this.statisticIndex].statisticId; 
 
    if (this.statisticIndex > -1) {
     
      this.baseService.showRootLoader = true;
      const apiRequest = {
        Model: {
          "ContraStatId": this.statisticId,
        }
      };
      this.PDService.getStatisticRequestByStatisticId(apiRequest, this.callbackMethodForGetRequestByStatisticId.bind(this));
      this.router.navigate(["pd/statistic/" + this.statisticId]);


  
    
  }
  }




  getOutput(event) {
    if (event) {
     // this.ngOnInit();
     this.router.navigate(["pd/overview"]);
    }
  }

  checkHolder(event) {
    let contract;
    contract = this.unitContractDetails.find(contract => contract.UnitContractDetailsId === event.value);
    if (contract.ContractHolderId && contract.ContractNumber != '') {
      this.isHasContractDetails = true;
    } else {
      this.isHasContractDetails = false;
    }
  }

  downloadPDF() {
    this.notificationsService.toastNotify(
      "info",
      "Information Message",
      "Download is in Progress!"
    );
    const apiRequest = {
      Model: {
        ProcessName: "ContractorStat",
        SourceId: this.statisticId,
        UserId: this.loggedInUserJSON.UserId
      }
    };
    this.PDService.downloadPDF(apiRequest, this.callbackMethodForDownloadPDF.bind(this));
  }

  callbackMethodForDownloadPDF(response) {
    if (response) {
      //Here assign the Byte array returned from API to data variable
      var fileDownLoadName = "pdf_contractorStat.pdf"; //Here we can assign name of the document
      FileUtility.downloadPDF(response, fileDownLoadName);
    }
  }

  approvalDetails() {
    if (this.status && this.status === StatisticStatus.Approved || this.status === StatisticStatus.Rejected) {
      this.isApprovedReject = true;
      switch (this.status) {
        case StatisticStatus.Approved:
          this.ApprovedRejectedDate = 'Approved Date'
          break;
        case StatisticStatus.Rejected:
          this.ApprovedRejectedDate = 'Rejected Date'
          break;
        default:
          break;
      }
      this.approvedRejectedDate = moment(moment.utc(this.statRequest.ApprovalDate).local()).toDate();
    }
  }

  saveAsDraft(SaveorUpdate: string) {
    this.baseService.showRootLoader = true;

    if (this.CSForm.valid && this.isHasContractDetails && this.checkValidation()) {
      this.GetContractorStatLocationDetail();
      const apiRequestUnit = {
        Model: {
          "SaveorUpdate": SaveorUpdate,
          "ContraStatId": this.CSForm.get('ContraStatId').value,
          "CreatedBy": this.createdBy,
          "ModifiedBy": this.loggedInUserJSON.UserId,
          "contractorName": this.CSForm.get('contractorName').value,
          "BaseUnit": this.CSForm.get('BaseUnit').value,
          "StatDate": moment(this.CSForm.get('StatDate').value).add(1, 'd'),
          "Status": this.status,
          "RejectRemark": this.CSForm.get('RejectRemark').value,

         // "Contract": 0,
         
        "Contract": this.CSForm.get('Contract').value ? this.CSForm.get('Contract').value : 0,
          "SafetyObsNotReported": this.CSForm.value.SafetyObsNotReported ? this.CSForm.value.SafetyObsNotReported : 0,
          "HazardsTourConducetd": this.CSForm.value.HazardsTourConducetd ? this.CSForm.value.HazardsTourConducetd : 0,

          "TrainingCompliance": this.CSForm.value.TrainingCompliance ? this.CSForm.value.TrainingCompliance : 0,
          "FitnessToWork": this.CSForm.value.FitnessToWork ? this.CSForm.value.FitnessToWork : 0,

          "EmergencyDrills": this.CSForm.value.EmergencyDrills ? this.CSForm.value.EmergencyDrills : 0,
          "InspectionsAudits": this.CSForm.value.InspectionsAudits ? this.CSForm.value.InspectionsAudits : 0,
          "VisitsByContractor": this.CSForm.value.VisitsByContractor ? this.CSForm.value.VisitsByContractor : 0,

          "Manhours": this.CSForm.value.Manhours ? this.CSForm.value.Manhours : 0,
          "PeopleOnBoardContractor": this.CSForm.value.PeopleOnBoardContractor ? this.CSForm.value.PeopleOnBoardContractor : 0,
          "PeopleOnBoardSubContractor": this.CSForm.value.PeopleOnBoardSubContractor ? this.CSForm.value.PeopleOnBoardSubContractor : 0,
          "LightVehicles": this.CSForm.value.LightVehicles ? this.CSForm.value.LightVehicles : 0,
          "KMLightVehicles": this.CSForm.value.KMLightVehicles ? this.CSForm.value.KMLightVehicles : 0,
          "HeavyVehicles": this.CSForm.value.HeavyVehicles ? this.CSForm.value.HeavyVehicles : 0,
          "KMHeavyVehicles": this.CSForm.value.KMHeavyVehicles ? this.CSForm.value.KMHeavyVehicles : 0,
          "LightBusses": this.CSForm.value.LightBusses ? this.CSForm.value.LightBusses : 0,
          "KMLightBusses": this.CSForm.value.KMLightBusses ? this.CSForm.value.KMLightBusses : 0,
          "HeavyBusses": this.CSForm.value.HeavyBusses ? this.CSForm.value.HeavyBusses : 0,
          "KMHeavyBusses": this.CSForm.value.KMHeavyBusses ? this.CSForm.value.KMHeavyBusses : 0,

          "NaturalGasProd": this.CSForm.value.NaturalGasProd ? this.CSForm.value.NaturalGasProd : 0,
          "FuelGasGen": this.CSForm.value.FuelGasGen ? this.CSForm.value.FuelGasGen : 0,
          "FuelGasTreater": this.CSForm.value.FuelGasTreater ? this.CSForm.value.FuelGasTreater : 0,
          "AllGasFlared": this.CSForm.value.AllGasFlared ? this.CSForm.value.AllGasFlared : 0,
          "TotalProducedWater": this.CSForm.value.TotalProducedWater ? this.CSForm.value.TotalProducedWater : 0,
          "PWReInjected": this.CSForm.value.PWReInjected ? this.CSForm.value.PWReInjected : 0,
          "PWEvaporated": this.CSForm.value.PWEvaporated ? this.CSForm.value.PWEvaporated : 0,
          "WaterAbstracted": this.CSForm.value.WaterAbstracted ? this.CSForm.value.WaterAbstracted : 0,
          "EPFDGS": this.CSForm.value.EPFDGS ? this.CSForm.value.EPFDGS : 0,
          "CampDGS": this.CSForm.value.CampDGS ? this.CSForm.value.CampDGS : 0,
          "ContractorDGS": this.CSForm.value.ContractorDGS ? this.CSForm.value.ContractorDGS : 0,
          "Vehicle": this.CSForm.value.Vehicle ? this.CSForm.value.Vehicle : 0,
          "MainsElectricity": this.CSForm.value.MainsElectricity ? this.CSForm.value.MainsElectricity : 0,
          //"MainsElectricityEPF": this.CSForm.value.MainsElectricityEPF ? this.CSForm.value.MainsElectricityEPF : 0,
          "MainsElectricityCamp": this.CSForm.value.MainsElectricityCamp ? this.CSForm.value.MainsElectricityCamp : 0,
          "MainsElectricityWells": this.CSForm.value.MainsElectricityWells ? this.CSForm.value.MainsElectricityWells : 0,
          "WellsDGS": this.CSForm.value.WellsDGS ? this.CSForm.value.WellsDGS : 0,
          "Other": this.CSForm.value.Other ? this.CSForm.value.Other : 0,
          "WaterConsumption": this.CSForm.value.WaterConsumption ? this.CSForm.value.WaterConsumption : 0,
          "HazardousWasteOily": this.CSForm.value.HazardousWasteOily ? this.CSForm.value.HazardousWasteOily : 0,
          "HazardousWasteChemical": this.CSForm.value.HazardousWasteChemical ? this.CSForm.value.HazardousWasteChemical : 0,
          "HazardousWasteDrilling": this.CSForm.value.HazardousWasteDrilling ? this.CSForm.value.HazardousWasteDrilling : 0,
          "HazardousWasteOther": this.CSForm.value.HazardousWasteOther ? this.CSForm.value.HazardousWasteOther : 0,
          "NonHazardScrap": this.CSForm.value.NonHazardScrap ? this.CSForm.value.NonHazardScrap : 0,
          "NonHazardWood": this.CSForm.value.NonHazardWood ? this.CSForm.value.NonHazardWood : 0,
          "NonHazardPlastic": this.CSForm.value.NonHazardPlastic ? this.CSForm.value.NonHazardPlastic : 0,
          "NonHazardDomestic": this.CSForm.value.NonHazardDomestic ? this.CSForm.value.NonHazardDomestic : 0,
          "NonHazardKitchen": this.CSForm.value.NonHazardKitchen ? this.CSForm.value.NonHazardKitchen : 0,
          "SewageWater": this.CSForm.value.SewageWater ? this.CSForm.value.SewageWater : 0,
          "OBMDisp": this.CSForm.value.OBMDisp ? this.CSForm.value.OBMDisp : 0,
          "NumOfConsignmentNote": this.CSForm.value.NumOfConsignmentNote ? this.CSForm.value.NumOfConsignmentNote : 0,
          "IsDraft":true,
          "SupportEvidenceDocs" : this.supportEvidence,
          "ContractorStatLocationDetail" : this.ContractorStatLocationDetail,
          "FuelGasGenerators": this.CSForm.value.FuelGasGenerators ? this.CSForm.value.FuelGasGenerators : 0,
          "StationarySource": this.CSForm.value.StationarySource ? this.CSForm.value.StationarySource : 0,
          "Generators": this.CSForm.value.Generators ? this.CSForm.value.Generators : 0
        },
      };
      this.PDService.saveContractorStat(
        apiRequestUnit,
        this.callbackMethodForContractStat.bind(this)
      );
    }
    else {
      this.baseService.showRootLoader = false;
      this.notificationsService.toastNotify(
        "error",
        "Error Message",
        "Kindly Fill in all Mandatory Fields as well as Quantity/Location in added records!"
      );
    }
  }

   //BOC Pritesh
   ReportshowDialog() {
    
    this.ReportUserId = this.loggedInUserJSON.UserId;
    this.ReportModule = "PD";
    this.ReportRecordId = this.statisticId;
    this.ReportProcessId = 0;
    this.dialogHeight = (window.innerHeight - 50).toString() + "px";
    this.dialogWidth = window.innerWidth.toString() + "px";
    this.ReportclosePopup = true;
  }
  ReportclosePopUp() {
    this.ReportclosePopup = false;
  }
  //EOC Pritesh

  getLocations() {
    if (this.login) {
      this.login.UnitId = (this.selectedUnit !== null && this.selectedUnit !== undefined) ? this.selectedUnit.UnitId : 0;
      const apiRequest = {
        Model: {
          ...this.login,
          GetActiveLocations: this.CSForm.get('ContraStatId').value === 0 ? true : false
        }
      };
      this.observationService.getLocationData(
        apiRequest,
        this.callbackMethodForGetLocationData.bind(this)
      );
    }
  }

  // call back method of get location
  callbackMethodForGetLocationData(response) {
    if (response === undefined) {
      this.serviceError();
    }
    if (response.Success) {
      this.locations = [];
      this.locations.push({Name:"--Select--",Value:0})
      const locationDetails = response.Result;
      locationDetails.forEach(location => {
        this.locations.push({
          Name: location.LocationName,
          Value: location.LocationId
        });
      });      
    }
    this.baseService.showRootLoader = false;
  }

  ContractorStatLocationDetailByComponent(component)
  {
    component.forEach(data => {
      this.ContractorStatLocationDetail.push(this.GetLocationQtyDetails(data.Id,data.ComponentId,data.Quantity,data.LocationId,false,false));
      });
  }

  GetContractorStatLocationDetail()
  {
      this.ContractorStatLocationDetail = [];
      this.ContractorStatLocationDetailByComponent(this.NaturalGasProduction);
      this.ContractorStatLocationDetailByComponent(this.TableFuelGasGenerators);
      this.ContractorStatLocationDetailByComponent(this.TableFuelGasTreater);
      this.ContractorStatLocationDetailByComponent(this.TableAllGasFlared);
      this.ContractorStatLocationDetailByComponent(this.TableTotalProducedWater);
      this.ContractorStatLocationDetailByComponent(this.TablePWReInjected);
      this.ContractorStatLocationDetailByComponent(this.TablePWEvaporated);
      this.ContractorStatLocationDetailByComponent(this.TableWaterAbstracted);
      this.ContractorStatLocationDetailByComponent(this.TableEPFDGS);
      this.ContractorStatLocationDetailByComponent(this.TableCampDGS);
      this.ContractorStatLocationDetailByComponent(this.TableContractorDGS);
      this.ContractorStatLocationDetailByComponent(this.TableVehicle);
      this.ContractorStatLocationDetailByComponent(this.TableStationarySource);
      this.ContractorStatLocationDetailByComponent(this.TableGenerators);
      this.ContractorStatLocationDetailByComponent(this.TableWellsDGS);
      this.ContractorStatLocationDetailByComponent(this.TableOther);
      this.ContractorStatLocationDetailByComponent(this.TableMainsElectricity);  
      //this.ContractorStatLocationDetailByComponent(this.TableMainsElectricityEPF); 
      this.ContractorStatLocationDetailByComponent(this.TableMainsElectricityCamp); 
      this.ContractorStatLocationDetailByComponent(this.TableMainsElectricityWells);    
    }
    
    CheckValidationForComponent(component)
    {
      if(component != null && component.length > 0)
      {
        component.forEach((action: { Quantity: number; ShowQuantityErrorMessage: boolean;LocationId: number; ShowLocationIdErrorMessage: boolean;}) => {
          if (action.Quantity <= 0 || (action.Quantity && action.Quantity.toString() === "0") || (!action.Quantity)) {
            action.ShowQuantityErrorMessage = true;
            this.isFormValid = false;
          }
          if (action.LocationId === 0 || (action.LocationId && action.LocationId.toString() === "0") || (!action.LocationId)) {
            action.ShowLocationIdErrorMessage = true;
            this.isFormValid = false;
          }
        });
      }
    }

    checkValidation()
    {
      this.isFormValid = true;
      this.CheckValidationForComponent(this.NaturalGasProduction);
      this.CheckValidationForComponent(this.TableFuelGasGenerators);
      this.CheckValidationForComponent(this.TableFuelGasTreater);
      this.CheckValidationForComponent(this.TableAllGasFlared);
      this.CheckValidationForComponent(this.TableTotalProducedWater);
      this.CheckValidationForComponent(this.TablePWReInjected);
      this.CheckValidationForComponent(this.TablePWEvaporated);
      this.CheckValidationForComponent(this.TableWaterAbstracted);
      this.CheckValidationForComponent(this.TableEPFDGS);
      this.CheckValidationForComponent(this.TableCampDGS);
      this.CheckValidationForComponent(this.TableContractorDGS);
      this.CheckValidationForComponent(this.TableVehicle);
      this.CheckValidationForComponent(this.TableStationarySource);
      this.CheckValidationForComponent(this.TableGenerators);
      this.CheckValidationForComponent(this.TableWellsDGS);
      this.CheckValidationForComponent(this.TableOther);
      this.CheckValidationForComponent(this.TableMainsElectricity);  
      //this.CheckValidationForComponent(this.TableMainsElectricityEPF);   
      this.CheckValidationForComponent(this.TableMainsElectricityCamp);   
      this.CheckValidationForComponent(this.TableMainsElectricityWells);    
      return this.isFormValid;
    }

    checkTableRows()
    {
      this.ShowNaturalGasProduction =  this.NaturalGasProduction.length > 0 ? true : false;
      this.ShowTableFuelGasGenerators =  this.TableFuelGasGenerators.length > 0 ? true : false;
      this.ShowTableFuelGasTreater =  this.TableFuelGasTreater.length > 0 ? true : false;
      this.ShowTableAllGasFlared =  this.TableAllGasFlared.length > 0 ? true : false;
      this.ShowTableTotalProducedWater =  this.TableTotalProducedWater.length > 0 ? true : false;
      this.ShowTablePWReInjected =  this.TablePWReInjected.length > 0 ? true : false;
      this.ShowTablePWEvaporated =  this.TablePWEvaporated.length > 0 ? true : false;
      this.ShowTableWaterAbstracted =  this.TableWaterAbstracted.length > 0 ? true : false;
      this.ShowTableEPFDGS =  this.TableEPFDGS.length > 0 ? true : false;
      this.ShowTableCampDGS =  this.TableCampDGS.length > 0 ? true : false;
      this.ShowTableContractorDGS =  this.TableContractorDGS.length > 0 ? true : false;
      this.ShowTableVehicle =  this.TableVehicle.length > 0 ? true : false;
      this.ShowTableStationarySource =  this.TableStationarySource.length > 0 ? true : false;
      this.ShowTableGenerators =  this.TableGenerators.length > 0 ? true : false;
      this.ShowTableWellsDGS =  this.TableWellsDGS.length > 0 ? true : false;
      this.ShowTableOther =  this.TableOther.length > 0 ? true : false;
      this.ShowTableMainsElectricity =  this.TableMainsElectricity.length > 0 ? true : false;
      //this.ShowTableMainsElectricityEPF =  this.TableMainsElectricityEPF.length > 0 ? true : false;
      this.ShowTableMainsElectricityCamp =  this.TableMainsElectricityCamp.length > 0 ? true : false;
      this.ShowTableMainsElectricityWells =  this.TableMainsElectricityWells.length > 0 ? true : false;
    }

    ResetAllLocationQuantityTables()
    {
      this.NaturalGasProduction = [];
      this.TableFuelGasGenerators = [];
      this.TableFuelGasTreater = [];
      this.TableAllGasFlared = [];
      this.TableTotalProducedWater = [];
      this.TablePWReInjected = [];
      this.TablePWEvaporated = [];
      this.TableWaterAbstracted = [];
      this.TableEPFDGS = [];
      this.TableCampDGS = [];
      this.TableContractorDGS = [];
      this.TableVehicle = [];
      this.TableStationarySource = [];
      this.TableGenerators = [];
      this.TableWellsDGS = [];
      this.TableOther = [];
      this.TableMainsElectricity = [];
      //this.TableMainsElectricityEPF = [];
      this.TableMainsElectricityCamp = [];
      this.TableMainsElectricityWells = [];
      this.ResetTotal();
      this.checkTableRows();
    }

    ResetTotal()
    {
      this.CSForm.patchValue({ NaturalGasProd:0 });
      this.CSForm.patchValue({ FuelGasGenerators:0});
      this.CSForm.patchValue({ FuelGasTreater:0});
      this.CSForm.patchValue({ AllGasFlared:0});
      this.CSForm.patchValue({ TotalProducedWater:0 });
      this.CSForm.patchValue({ PWReInjected:0 });
      this.CSForm.patchValue({ PWEvaporated:0 });
      this.CSForm.patchValue({ WaterAbstracted:0 });
      this.CSForm.patchValue({ EPFDGS:0 });
      this.CSForm.patchValue({ CampDGS:0 });
      this.CSForm.patchValue({ ContractorDGS:0 });
      this.CSForm.patchValue({ Vehicle:0 });
      this.CSForm.patchValue({ StationarySource:0 });
      this.CSForm.patchValue({ Generators:0 });
      this.CSForm.patchValue({ WellsDGS:0 });
      this.CSForm.patchValue({ Other:0 });
      this.CSForm.patchValue({ MainsElectricity:0 });
      //this.CSForm.patchValue({ MainsElectricityEPF:0 });
      this.CSForm.patchValue({ MainsElectricityCamp:0 });
      this.CSForm.patchValue({ MainsElectricityWells:0 });
    }
}

class LocationQtyDetails
{
   Id: number;
   ComponentId : number;
   Quantity : number; 
   LocationId: number;
   ShowQuantityErrorMessage:boolean;
   ShowLocationIdErrorMessage:boolean;
   locations:LocationsList[];
 }

 class LocationsList
 {
  Name : string;
  Value: number;
 }
